var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChicNGlamLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 71 L 261.5 73 L 260.5 71 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 72 L 214.5 75 L 212.5 72 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 72 L 222.5 74 L 221.5 72 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 75 L 276.5 79 L 279.5 75 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 76 L 222.5 78 L 221.5 76 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 76 L 285.5 78 L 286.5 76 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 76 L 289.5 78 L 288.5 76 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 76 L 297.5 78 L 298.5 76 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 77 L 234.5 79 L 235.5 77 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 81 L 293.5 83 L 294.5 81 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 82 L 206.5 86 L 203.5 82 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 82 L 280.5 84 L 279.5 82 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 296.5 82 L 295.5 84 L 296.5 82 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 90 L 181.5 92 L 180.5 90 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 275.5 91 L 276.5 93 L 275.5 91 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 92 L 298.5 94 L 297.5 92 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 96 L 157.5 98 L 158.5 96 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300.5 96 L 299.5 98 L 300.5 96 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 100 L 198.5 102 L 197.5 100 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 346.5 101 L 347.5 103 L 346.5 101 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 102 L 157.5 104 L 158.5 102 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 339.5 103 Q 341.8 102.3 341 104.5 L 341.5 106 L 339.5 103 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 106 L 220.5 108 L 221.5 106 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 106 L 279.5 108 L 278.5 106 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 109 L 263.5 111 L 262.5 109 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 109 L 320.5 111 L 319.5 109 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 109 L 326 110.5 L 324 111.5 L 325.5 109 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 110 L 349.5 112 L 348.5 110 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 111 L 184.5 113 L 183.5 111 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 263.5 114 L 262.5 116 L 263.5 114 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 115 L 177 118.5 L 176 118.5 L 176.5 115 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 116 L 292.5 118 L 293.5 116 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 116 L 324 117.5 L 323.5 119 L 323 117.5 L 324.5 116 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171 118 L 173 118.5 L 170 120.5 L 171 118 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 118 L 346.5 120 L 345.5 118 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 122 L 167.5 124 L 168.5 122 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 122 L 171.5 124 L 172.5 122 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 122 L 311.5 124 L 312.5 122 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 317.5 122 L 316.5 124 L 317.5 122 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 322.5 122 L 321.5 124 L 322.5 122 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 122 L 328.5 124 L 327.5 122 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 122 L 342.5 125 L 340.5 122 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 332.5 123 L 333.5 125 L 332.5 123 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 124 L 151.5 126 L 152.5 124 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 125 L 178.5 128 L 180.5 125 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 125 L 245.5 130 L 249.5 125 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 127 L 168.5 130 L 170.5 127 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 311.5 127 L 314.5 131 L 311.5 127 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 131 L 136.5 133 L 137.5 131 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 131 L 141.5 134 Q 138.5 132.5 141.5 131 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 374.5 135 L 375.5 137 L 374.5 135 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 341.5 136 L 340.5 138 L 341.5 136 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 136 L 368 136.5 L 365.5 137 L 365.5 136 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 141 L 344.5 143 L 345.5 141 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 155 L 129.5 158 L 131.5 155 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 156 L 117.5 158 L 118.5 156 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 156 L 137.5 158 L 136.5 156 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342 157 L 344 157.5 L 342 158.5 L 342 157 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 163 L 155 164.5 L 151.5 168 L 154 164.5 L 153.5 163 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 163 L 170.5 165 L 171.5 163 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 163 L 348.5 165 L 349.5 163 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 167 L 105.5 169 L 104.5 167 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 167 L 282.5 169 L 283.5 167 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 172 L 161.5 174 L 162.5 172 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 174 L 275 176.5 L 274 176.5 L 274.5 174 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 176 L 286.5 178 L 287.5 176 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 182 L 116.5 184 L 115.5 182 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 182 L 121.5 184 L 122.5 182 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 183 L 371.5 185 L 372.5 183 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 187 L 299.5 192 L 303.5 187 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 190 L 305.5 193 L 307.5 190 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 191 L 294.5 193 L 295.5 191 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 390.5 197 L 389.5 199 L 390.5 197 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 366.5 198 L 365.5 200 L 366.5 198 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 201 L 305.5 204 L 303.5 201 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 201 L 388.5 203 L 389.5 201 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 202 L 193.5 205 L 195.5 202 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 203 L 137.5 205 L 136.5 203 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 204 L 390.5 206 L 391.5 204 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 208 L 119 210 L 117 209.5 L 118.5 208 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 385.5 208 L 386 210.5 L 385 210.5 L 385.5 208 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 211 L 121.5 213 L 122.5 211 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 212 L 107.5 215 L 105.5 212 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 227 L 117 228.5 L 115 229.5 L 116.5 227 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 228 L 106.5 230 L 105.5 228 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 228 L 345 229.5 L 344.5 231 L 344 229.5 L 345.5 228 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 230 L 383.5 233 L 381.5 230 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 230 L 400.5 232 L 401.5 230 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 402.5 232 L 401.5 234 L 402.5 232 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 236 L 112.5 238 L 111.5 236 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 236 L 334 236.5 L 331.5 237 L 331.5 236 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 237 L 82.5 239 L 83.5 237 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 240 L 232.5 242 L 233.5 240 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 240 L 249.5 242 L 250.5 240 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 245 L 129.5 248 L 131.5 245 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 250 L 250 254.5 L 249 254.5 L 249.5 250 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 252 L 254.5 255 L 252.5 252 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 254 L 260 256 L 260.5 254 L 262 256.5 L 259.5 257 L 256 256 L 256.5 254 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 255 L 83.5 257 Q 80.7 257.7 82.5 255 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 255 L 236.5 257 L 235.5 255 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 256 L 263.5 258 L 264.5 256 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 260 L 83.5 262 L 82.5 260 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 416.5 261 L 415.5 263 L 416.5 261 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 263 L 237.5 266 L 239.5 263 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 265 L 249.5 267 L 250.5 265 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 270.5 265 L 271.5 267 L 270.5 265 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 385.5 268 L 386.5 270 L 385.5 268 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 414.5 268 L 412.5 271 L 414.5 268 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 271 L 102 273.5 L 100 272.5 L 100.5 271 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 273.5 272 L 274.5 274 L 273.5 272 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 399.5 273 L 398.5 275 L 399.5 273 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 414.5 274 L 413.5 276 L 414.5 274 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 275 L 239.5 277 L 240.5 275 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 278 L 227.5 280 L 228.5 278 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 282 L 108 284.5 L 106 285.5 L 107.5 282 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 398.5 283 L 399.5 285 L 398.5 283 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 408.5 283 L 409.5 285 L 408.5 283 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 286 L 95.5 288 L 96.5 286 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 287 L 97.5 289 L 98.5 287 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 287 L 261.5 289 L 262.5 287 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 413.5 287 L 411.5 290 L 413.5 287 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 394.5 288 L 393.5 290 L 394.5 288 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 289 L 227.5 291 L 228.5 289 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 412.5 292 L 412 293.5 L 411.5 295 L 411 293.5 L 412.5 292 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 411.5 298 L 410.5 300 L 411.5 298 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 299 L 240.5 301 L 241.5 299 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 299 L 371.5 301 L 370.5 299 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 300 L 250 304.5 L 249 304.5 L 249.5 300 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 300 L 252.5 303 L 251 302.5 L 254.5 300 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 302 L 131 304.5 L 130 304.5 L 130.5 302 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 311 L 360 313.5 L 359 313.5 L 359.5 311 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 384.5 311 L 385 312.5 L 384.5 315 Q 381.8 313.8 384 312.5 L 384.5 311 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 312 L 253.5 314 L 254.5 312 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 313 L 250.5 315 L 249.5 313 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 318 L 112.5 320 L 113.5 318 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 318 L 381.5 320 L 380.5 318 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 329 L 174.5 336 L 168.5 329 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 329 L 328.5 333 L 331.5 329 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 330 L 366.5 332 Q 363.7 332.7 365.5 330 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 338 L 368 339.5 L 367.5 341 L 367 339.5 L 368.5 338 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 345 L 154 347.5 L 153 347.5 L 153.5 345 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 345 L 320.5 347 L 321.5 345 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 349 L 113.5 351 L 114.5 349 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 354 L 357 356 L 355 355.5 L 356.5 354 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 356 L 141.5 358 L 140 357.5 L 142.5 356 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 358 L 167 362.5 L 166 362.5 L 166.5 358 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 358 L 357 360.5 L 355 359.5 L 355.5 358 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 338.5 359 L 339 361.5 L 338 361.5 L 338.5 359 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 360 Q 156.8 359.3 156 361.5 L 159.5 366 L 154.5 360 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 361 L 347.5 365 L 350.5 361 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 323.5 364 L 324 366.5 L 323 366.5 L 323.5 364 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 338.5 364 L 337.5 366 L 338.5 364 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 255.5 370 L 253.5 373 L 255.5 370 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 370 L 290.5 372 L 289.5 370 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 370 L 322.5 372 L 321.5 370 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 334.5 370 L 331.5 374 L 334.5 370 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 371 L 339.5 373 L 340.5 371 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 372 L 168.5 374 L 167.5 372 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 374 L 175.5 376 L 174.5 374 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 377 L 371.5 379 L 369 378.5 L 370.5 377 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 378 L 339.5 380 L 340.5 378 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 313.5 385 L 314 387 L 312 386.5 L 313.5 385 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 388 L 318.5 390 L 319.5 388 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 390 L 212.5 392 L 213.5 390 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 322 391 L 324 391.5 L 322 392.5 L 322 391 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 393 L 296.5 395 L 297.5 393 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 394 L 210.5 396 L 209.5 394 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 395 L 219 397.5 L 218 397.5 L 217.5 395 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 396 L 325.5 398 L 324.5 396 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 397 L 211.5 399 L 212.5 397 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 397 L 288.5 399 L 287.5 397 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 400 L 159 401.5 L 158.5 403 L 158 401.5 L 159.5 400 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 404 L 325.5 406 L 324.5 404 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 408 L 252.5 410 L 253.5 408 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 408 L 289.5 411 L 287.5 408 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(241,241,241)",
    stroke: "rgb(241,241,241)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 418 L 279.5 420 L 278.5 418 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 69 L 217.5 71 L 218.5 69 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 285.5 74 L 284.5 76 L 285.5 74 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 268.5 79 L 268 80.5 Q 268.8 82.8 266.5 82 L 268.5 79 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 84 L 293.5 86 L 294.5 84 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 85 L 248.5 87 L 247.5 85 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 93 L 235.5 95 L 234.5 93 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 93 L 264.5 95 L 265.5 93 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 97 L 345.5 101 Q 343.8 97.9 342 99.5 L 342.5 97 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 98 L 222.5 100 L 223.5 98 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 101 L 160.5 103 L 159.5 101 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 103 L 207 105.5 L 206 105.5 L 206.5 103 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 108 L 190.5 110 L 191.5 108 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 108 L 203.5 110 L 204.5 108 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 317.5 108 L 318.5 110 L 317.5 108 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 109 L 315 110 L 314.5 112 L 312.5 109 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 109 L 328.5 111 L 329.5 109 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 111 L 151 112.5 L 149 113.5 L 150.5 111 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 114 L 207.5 118 L 210.5 114 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 114 Q 291.3 117.1 293 115.5 L 291.5 117 L 289.5 114 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 114 L 313.5 116 L 312.5 114 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 116 L 168.5 118 L 169.5 116 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 323.5 116 L 322.5 118 L 323.5 116 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 116 L 333 118.5 L 330.5 117 L 329.5 116 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 117 L 284 117.5 L 283.5 120 L 281.5 117 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 311.5 120 L 310.5 122 L 311.5 120 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 120 L 348.5 122 L 347.5 120 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 123 L 141 125.5 L 140.5 127 L 140 125.5 L 142.5 123 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 123 L 161.5 126 Q 158.5 124.5 161.5 123 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 305.5 125 L 304.5 127 L 305.5 125 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 126 L 321.5 128 L 320.5 126 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 127 L 120 129.5 L 119 129.5 L 119.5 127 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 127 L 186.5 130 L 188.5 127 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 128 L 175.5 131 L 177.5 128 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 315.5 129 L 316.5 131 L 315.5 129 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 129 L 324.5 131 L 325.5 129 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 137 L 125.5 139 L 126.5 137 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 141 L 165.5 143 L 166.5 141 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 147 L 166.5 149 L 165.5 147 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 147 L 171.5 149 L 172.5 147 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 366.5 147 L 367.5 149 L 366.5 147 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 148 L 152.5 150 L 151.5 148 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 154 L 244 156 L 246 156.5 L 244.5 157 L 243.5 154 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 156 L 180.5 158 L 179.5 156 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 371.5 159 L 372.5 161 L 371.5 159 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 163 L 325.5 165 L 324.5 163 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 165 L 167.5 168 L 169.5 165 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 379.5 166 L 380 168 L 378 167.5 L 379.5 166 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 167 L 168.5 171 L 171.5 167 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 170 L 163.5 172 L 164.5 170 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 171 L 192.5 173 L 193.5 171 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 178 L 239.5 180 L 240.5 178 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 306.5 184 L 304.5 187 L 306.5 184 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 192 L 170.5 194 L 171.5 192 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 196 L 305.5 199 L 303.5 196 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 197 L 116.5 199 L 117.5 197 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300.5 198 L 302.5 201 L 300.5 198 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 199 L 133.5 201 L 134.5 199 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 200 L 106.5 202 L 105.5 200 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 394.5 201 L 392.5 204 L 394.5 201 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 201 L 400.5 203 L 401.5 201 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 203 L 112 204.5 L 110.5 204 L 109.5 203 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 203 L 116.5 205 L 115.5 203 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 214 L 383.5 216 L 382.5 214 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 215 L 96 216.5 L 95.5 218 L 95 216.5 L 96.5 215 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 217 L 253.5 219 L 254.5 217 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 217 L 381.5 219 L 380.5 217 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 399.5 217 L 398.5 219 L 399.5 217 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401 226 L 403 226.5 L 401 227.5 L 401 226 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 232 L 98.5 234 L 97.5 232 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 242 L 247.5 244 L 248.5 242 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 366.5 243 L 370.5 248 L 366.5 243 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 246 L 83.5 248 L 82.5 246 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 255 L 103.5 257 L 104.5 255 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 255 L 240.5 257 L 241.5 255 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 256 L 172.5 258 L 173.5 256 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 394.5 256 L 393.5 258 L 394.5 256 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 257 L 236 258.5 L 235.5 260 L 235 258.5 L 236.5 257 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 258 L 267 258.5 L 264.5 260 L 265.5 258 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 271.5 260 L 270.5 264 L 269 261 L 271.5 260 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82 262 L 84 262.5 L 82 263.5 L 82 262 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 263 L 233.5 265 L 234.5 263 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 264 L 273.5 266 L 274.5 264 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 267 L 247.5 269 L 248.5 267 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 269 L 283 271.5 L 282 271.5 L 282.5 269 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 390.5 269 L 391.5 271 L 390.5 269 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 270 L 387 271.5 L 385 272.5 L 386.5 270 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 275 L 392.5 277 L 391.5 275 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 269.5 276 L 270 278.5 L 269 278.5 L 269.5 276 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 279 L 89.5 281 L 90.5 279 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 282 L 98.5 284 L 99.5 282 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 273.5 282 L 272.5 284 L 273.5 282 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 396.5 286 L 395.5 288 L 396.5 286 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 287 L 89.5 289 L 87 288.5 L 88.5 287 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 270.5 287 L 271.5 289 L 270.5 287 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 288 L 250.5 290 L 249.5 288 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 289 L 234 290.5 L 232.5 291 L 231.5 289 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 290 L 239.5 292 L 238.5 290 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 293 L 107.5 295 L 106.5 293 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 269.5 293 L 272 294.5 L 270.5 294 L 269.5 293 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 295 L 90.5 297 L 89.5 295 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 295 L 265.5 297 L 264.5 295 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 410.5 295 L 409.5 297 L 410.5 295 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 297 L 240.5 299 L 239.5 297 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 271.5 300 L 270.5 302 L 271.5 300 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 301 L 243 302.5 L 242.5 304 L 242 302.5 L 243.5 301 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 411.5 303 L 410.5 305 L 411.5 303 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 308 L 362 312.5 L 361 312.5 L 361.5 308 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 310 L 248.5 313 L 246.5 310 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 404.5 317 L 403.5 319 L 404.5 317 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 400.5 326 L 401.5 328 L 400.5 326 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 327 L 129.5 329 L 128.5 327 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 336 L 254.5 338 L 253.5 336 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 339 L 133.5 341 Q 130.7 341.7 132.5 339 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 376.5 339 L 377.5 341 L 376.5 339 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 341 L 252.5 342 L 254 341.5 L 251.5 343 L 250.5 341 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 344 L 164 346.5 L 163 346.5 L 163.5 344 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 334.5 348 L 335 352.5 L 334 352.5 L 334.5 348 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 348 L 363 350.5 L 361 349.5 L 361.5 348 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 354.5 350 L 353.5 352 L 354.5 350 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 351 L 349.5 353 L 350.5 351 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 354.5 356 L 355.5 358 L 354.5 356 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 357 L 153.5 360 L 151.5 357 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 357 L 166 360.5 L 165 360.5 L 165.5 357 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 360 L 143 361.5 L 141 362.5 L 142.5 360 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 361 L 341.5 365 L 344.5 361 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 334.5 362 L 333.5 364 L 334.5 362 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 365 L 164 369.5 L 160 366.5 L 160.5 365 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 346.5 365 L 346 366.5 Q 346.8 368.8 344.5 368 L 341.5 372 L 341 370.5 L 346.5 365 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 371 L 322 374.5 L 321 374.5 L 321.5 371 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 372 L 326.5 374 L 325.5 372 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 374 L 350 374.5 L 347.5 375 L 347.5 374 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 379 L 287 381.5 L 286 381.5 L 286.5 379 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 363.5 381 L 362.5 383 L 363.5 381 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 382 L 318.5 384 L 319.5 382 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 383 L 185 384.5 L 184.5 386 L 183.5 384 L 185.5 383 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 384 L 315.5 386 L 316.5 384 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 387 L 172.5 389 L 171.5 387 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 389 L 282.5 391 L 281.5 389 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300.5 390 L 298.5 393 L 300.5 390 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 391 L 196.5 393 L 197.5 391 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 391 Q 203.5 392.5 200.5 394 L 200.5 391 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 393 L 284.5 396 L 286.5 393 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 394 L 252.5 396 L 253.5 394 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 290.5 394 L 292 396.5 L 291 396.5 L 290.5 394 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 399 L 243.5 401 L 244.5 399 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 400 L 339.5 402 L 340.5 400 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 403 L 298.5 405 L 297.5 403 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 404 L 282 405.5 L 280.5 406 L 279.5 404 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 405 L 238.5 407 L 239.5 405 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 290.5 405 L 292.5 408 L 290.5 405 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 412 L 244.5 414 L 243.5 412 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 255.5 413 L 256.5 415 L 255.5 413 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 413 L 271.5 415 L 272.5 413 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 268.5 422 L 267.5 424 L 268.5 422 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(220,220,220)",
    stroke: "rgb(220,220,220)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 432 L 252 432.5 L 248.5 433 L 248.5 432 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 71 L 289.5 73 L 288.5 71 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 73 L 249.5 75 L 250.5 73 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 79 L 202.5 81 L 203.5 79 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 79 L 232.5 81 L 231.5 79 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 296.5 79 L 297.5 81 L 296.5 79 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 81 L 214.5 83 L 213.5 81 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 271.5 81 L 272.5 83 L 271.5 81 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 81 L 282.5 86 L 286.5 81 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 92 L 224 92.5 L 221.5 93 L 221.5 92 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 97 L 178 97.5 L 175.5 98 L 175.5 97 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 97 L 202.5 99 L 203.5 97 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 97 L 325 97.5 L 321.5 98 L 321.5 97 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 98 L 172.5 100 L 171.5 98 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 99 L 350.5 101 Q 347.7 101.7 349.5 99 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 100 L 201 100.5 L 198.5 101 L 198.5 100 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300 100 L 302 100.5 L 300 101.5 L 300 100 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 103 L 169.5 105 L 168.5 103 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 103 L 207.5 105 L 208.5 103 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 291.5 103 L 292.5 105 L 291.5 103 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 103 L 341.5 105 L 342.5 103 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 104 L 202.5 106 L 203.5 104 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 296.5 104 L 297.5 106 L 296.5 104 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 106 L 179 106.5 L 174.5 107 L 174.5 106 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 106 L 327 106.5 L 321.5 107 L 321.5 106 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 108 L 184 108.5 L 181.5 110 L 182.5 108 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 109 L 140.5 111 L 139.5 109 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 109 L 179 109.5 L 176.5 110 L 176.5 109 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 109 L 324 109.5 L 320.5 110 L 320.5 109 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 110 L 185.5 112 L 186.5 110 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 113 L 148.5 115 L 147.5 113 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 113 Q 217.5 114.5 214.5 116 L 214.5 113 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 285.5 113 L 284.5 115 L 285.5 113 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 117 L 150 118.5 L 148 119.5 L 149.5 117 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 117 L 370 121.5 L 369 121.5 L 369.5 117 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 334.5 118 L 333.5 120 L 334.5 118 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 328.5 119 L 331 119.5 L 330 120.5 L 331.5 123 L 328.5 119 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 120 L 214.5 122 L 215.5 120 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 121 L 150.5 123 L 149.5 121 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 122 L 160 122.5 Q 157.9 125.8 157.5 122 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 339.5 124 L 340.5 126 L 339.5 124 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 125 L 334.5 130 L 330.5 125 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 379.5 125 L 380.5 127 L 379.5 125 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 126 L 172.5 129 L 174.5 126 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 127 L 166.5 129 L 167.5 127 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 128 L 173.5 131 L 175.5 128 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 128 L 177.5 132 L 180.5 128 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 128 L 323 132.5 L 322 132.5 L 320.5 130 L 319 130.5 L 319.5 128 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 322.5 128 L 325 128.5 Q 322.9 131.8 322.5 128 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 129 L 349.5 131 L 348.5 129 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 130 L 359.5 132 L 357 131.5 L 358.5 130 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 133 L 351.5 136 L 350.5 134 Q 352 136.5 353.5 133 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 139 Q 363.8 138.3 363 140.5 L 361.5 139 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 141 L 334.5 143 L 333.5 141 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 142 L 365.5 144 L 364.5 142 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 148 L 118.5 150 L 117.5 148 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 149 L 132 150.5 L 131.5 152 L 131 150.5 L 132.5 149 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 149 L 349.5 151 L 350.5 149 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 371.5 149 L 373 151.5 L 372 151.5 L 371.5 149 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 150 L 179.5 152 L 180.5 150 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 392.5 151 L 394 153.5 L 393 153.5 L 392.5 151 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 375.5 155 L 376 157.5 L 375 157.5 L 375.5 155 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 396.5 157 L 398 159.5 L 397 159.5 L 396.5 157 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 158 L 114.5 160 L 113.5 158 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 161 L 127.5 164 L 126 163.5 L 129.5 161 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 165 L 144.5 167 L 143.5 165 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 165 L 172.5 167 L 173.5 165 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 166 L 128 167.5 L 126 168.5 L 126.5 167 L 125.5 166 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 167 Q 102.5 168.5 99.5 170 L 99.5 167 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 167 Q 123.5 168.5 120.5 170 L 120.5 167 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 168 L 165.5 170 L 166.5 168 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 399.5 169 L 400.5 171 L 399.5 169 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 375.5 170 L 377 172.5 L 376 172.5 L 375.5 170 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 393.5 170 L 394 171.5 L 392 172.5 L 393.5 170 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 171 L 166.5 173 L 167.5 171 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 175 L 100.5 177 Q 97.7 177.7 99.5 175 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 177 L 101.5 179 L 102.5 177 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 178 L 251 178.5 L 248.5 179 L 248.5 178 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 179 L 239 179.5 L 236.5 180 L 236.5 179 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 180 L 392.5 182 L 391.5 180 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 181 Q 105.8 180.3 105 182.5 L 103.5 181 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 181 L 359.5 183 L 358.5 181 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 182 L 307.5 184 L 308.5 182 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 185 L 209.5 187 L 210.5 185 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 188 L 138.5 190 L 137.5 188 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 189 L 98.5 191 L 99.5 189 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 190 L 172.5 192 L 173.5 190 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 388.5 190 L 387.5 192 L 388.5 190 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 193 L 131.5 195 L 130.5 193 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 195 L 118.5 197 L 119.5 195 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 195 L 299.5 198 L 297.5 195 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 395.5 199 L 397 199.5 L 394.5 201 L 395.5 199 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 202 L 109.5 206 L 106.5 202 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 203 L 187.5 205 L 186.5 203 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 384.5 203 L 383.5 205 L 384.5 203 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 205 L 116.5 207 L 117.5 205 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335.5 208 L 334.5 210 L 335.5 208 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 214 L 118 215.5 L 115 217.5 L 117.5 214 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 215 L 328.5 217 L 329.5 215 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 216 L 106.5 219 L 104.5 216 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 384.5 216 L 387 217.5 L 385 218.5 L 384.5 216 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 217 L 250.5 219 L 249.5 217 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 394.5 217 L 392.5 220 L 394.5 217 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 218 L 117.5 220 L 118.5 218 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 220 L 160.5 222 L 159.5 220 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 220 Q 249.8 219.3 249 221.5 L 247.5 220 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 221 L 115.5 224 L 117.5 221 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 221 L 181.5 223 L 180.5 221 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 383.5 222 L 384.5 224 L 383.5 222 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 223 L 382.5 226 L 380.5 223 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 398.5 225 L 396.5 228 L 398.5 225 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 227 L 323 227.5 L 322.5 230 L 320.5 227 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 404.5 230 L 403.5 232 L 404.5 230 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 233 L 108 235.5 L 107 235.5 L 107.5 233 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 409.5 242 L 408.5 244 L 409.5 242 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 417.5 246 L 416.5 248 L 417.5 246 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 249 L 252.5 251 Q 249.7 251.7 251.5 249 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 250 L 132.5 253 L 130.5 250 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 250 L 255 251.5 L 253 252.5 L 254.5 250 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 252 L 243.5 254 L 244.5 252 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 256 L 104.5 258 L 105.5 256 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 259 L 217.5 261 L 218.5 259 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 259 L 254 259.5 L 248.5 260 L 248.5 259 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 395.5 259 L 396 262.5 L 395 262.5 L 395.5 259 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 261 Q 232.8 260.3 232 262.5 L 230.5 266 L 230 263.5 L 230.5 261 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 403.5 263 L 404 264.5 L 402 265.5 L 403.5 263 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 266 L 239.5 268 L 240.5 266 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 273.5 268 L 274.5 270 L 272 269.5 L 273.5 268 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 268 L 392 269.5 L 390 270.5 L 391.5 268 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 270 L 229 271.5 L 227 272.5 L 228.5 270 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 273.5 273 L 274.5 275 L 273.5 273 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 266.5 276 L 267.5 278 L 266.5 276 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 278 L 246.5 280 L 245.5 278 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 408.5 278 L 409.5 280 L 408.5 278 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 279 L 381.5 281 L 380.5 279 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 280 L 255 280.5 L 252.5 282 L 253.5 280 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 280 L 273.5 282 L 274.5 280 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 282 L 249.5 284 L 250.5 282 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 285 Q 90 287 85.5 289 L 85 287 L 87 286.5 L 86.5 285 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 286 L 105.5 289 L 107.5 286 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 286 L 249 287.5 L 247.5 287 L 246.5 286 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 377.5 286 L 378.5 288 L 377.5 286 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 287 L 241.5 290 L 239.5 287 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 392.5 287 L 393.5 289 L 392.5 287 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 289 L 109.5 291 L 108.5 289 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 289 L 231 291.5 L 230 291.5 L 230.5 289 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 290 L 225.5 292 L 226.5 290 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 294 L 380.5 296 L 381.5 294 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 388.5 294 L 389.5 296 L 388.5 294 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 297 L 381.5 299 L 382.5 297 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 298 L 259.5 300 L 260.5 298 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 299 L 100.5 301 L 101.5 299 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 395.5 300 L 396.5 302 L 395.5 300 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 301 L 106.5 303 L 107.5 301 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 301 L 384.5 304 L 382.5 301 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 302 L 255 304.5 L 254 304.5 L 253.5 302 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251 304 Q 254 303 253 306 Q 250 307 251 304 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 306 L 120 307.5 L 118.5 310 L 117 309.5 L 119 309 L 120.5 306 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 311 L 95.5 313 L 94.5 311 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 319 Q 355.8 319.8 355 323.5 L 354 323.5 L 353.5 319 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 357.5 319 L 358.5 321 Q 355.7 321.7 357.5 319 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 373.5 321 L 376 321.5 Q 373.9 324.8 373.5 321 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 322 L 140.5 324 L 139.5 322 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 325 L 361.5 327 L 360.5 325 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 328 L 353 330.5 L 352 330.5 L 352.5 328 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335.5 329 L 334.5 331 L 335.5 329 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 330 L 253 331.5 L 251.5 332 L 250.5 330 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 331 L 169.5 335 L 166.5 331 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 334 L 351.5 336 L 350.5 334 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 335 L 120 335.5 L 115.5 336 L 115.5 335 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 336 L 253 336.5 L 249.5 338 L 250.5 336 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 337 L 105.5 339 L 106.5 337 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 378.5 340 L 382 340.5 L 378.5 341 L 378.5 340 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 343 L 352 345.5 L 351 345.5 L 351.5 343 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 344 L 110.5 346 L 111.5 344 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 347 L 143.5 349 L 144.5 347 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 347 L 343 352.5 L 342 352.5 L 342.5 347 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 348 L 139 349.5 L 138.5 351 L 138 349.5 L 139.5 348 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 349 L 116.5 351 L 117.5 349 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 350 L 129 350.5 L 123.5 351 L 123.5 350 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 350 L 377 350.5 L 370.5 351 L 370.5 350 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 354 L 166 356.5 L 165 356.5 L 165.5 354 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 367.5 355 L 371 355.5 L 367.5 356 L 367.5 355 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 356 L 344.5 358 L 345.5 356 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 357 L 334 360.5 L 333 360.5 L 333.5 357 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 357 L 347.5 359 L 348.5 357 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 362 L 334.5 364 L 333.5 362 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 362 L 357.5 364 L 358.5 362 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 365 L 338.5 368 L 340.5 365 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 369 L 153 369.5 L 146.5 370 L 146.5 369 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 346.5 369 L 349 369.5 L 346.5 370 L 346.5 369 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 370 L 182 372.5 L 181 372.5 L 181.5 370 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 372 L 210.5 374 L 209.5 372 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 373 L 184 376.5 L 183 376.5 L 183.5 373 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 374 Q 152.8 373.3 152 375.5 L 150.5 374 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 375 L 165.5 377 Q 162.7 377.7 164.5 375 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 378 L 165 378.5 L 162.5 380 L 161.5 378 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 336.5 378 Q 339.8 376.9 339 379.5 L 337.5 379 L 336.5 378 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 379 L 201.5 381 L 202.5 379 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 380 L 322 382 L 320 381.5 L 321.5 380 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 381 L 195.5 383 L 196.5 381 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 337.5 382 L 340 382.5 L 337.5 383 L 337.5 382 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 387 L 232.5 389 L 233.5 387 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 305.5 388 L 303.5 391 L 305.5 388 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 389 L 196.5 391 L 195.5 389 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 391 L 315.5 393 L 314.5 391 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 310.5 394 L 309.5 396 L 310.5 394 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 395 L 283.5 397 L 282.5 395 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 397 L 349.5 399 L 350.5 397 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260 399 L 262 399.5 L 260 400.5 L 260 399 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 399 L 281.5 401 L 282.5 399 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 405 L 220 405.5 L 217.5 406 L 217.5 405 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 407 L 206.5 409 L 207.5 407 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 407 L 239 407.5 L 235.5 408 L 235.5 407 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 407 L 265 407.5 L 260.5 409 L 261.5 407 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 310.5 409 L 309.5 411 L 310.5 409 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 411 L 273.5 413 L 274.5 411 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 414 L 244.5 416 L 243.5 414 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 416 L 246.5 419 L 248.5 416 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(198,198,198)",
    stroke: "rgb(198,198,198)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 428 L 241.5 430 L 240.5 428 Z "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 0 L 500 0 L 500 500 L 0 500 L 0 0 Z M 249 67 L 244 71 L 240 71 L 237 75 Q 238 78 236 77 L 234 81 L 222 72 Q 219 73 220 71 L 217 69 L 221 77 L 229 82 L 234 82 L 233 87 L 233 92 L 237 99 L 250 106 L 258 101 L 261 101 L 267 92 L 266 82 Q 273 83 277 79 L 284 69 L 283 68 L 281 71 L 268 80 Q 265 81 266 79 L 263 77 L 262 73 Q 261 70 257 71 L 252 67 L 249 67 Z M 292 67 L 290 70 Q 282 80 268 84 L 269 86 L 274 86 L 285 79 L 292 70 L 292 67 Z M 209 68 L 211 74 Q 217 82 228 86 Q 234 88 233 84 Q 218 81 210 70 Q 211 67 209 68 Z M 202 76 Q 200 80 203 83 L 214 91 L 221 93 Q 224 94 225 92 L 209 84 L 202 76 Z M 211 76 L 212 81 Q 217 88 227 91 Q 233 93 232 89 Q 220 86 212 78 Q 213 75 211 76 Z M 288 76 L 288 78 Q 281 85 270 89 Q 267 88 268 91 L 276 90 L 277 93 Q 287 93 293 87 L 299 79 L 299 76 L 297 79 Q 291 87 279 90 L 277 90 L 282 87 L 290 78 Q 291 75 288 76 Z M 186 87 L 186 88 L 195 89 L 208 94 L 208 95 L 191 90 L 181 90 L 180 92 L 183 91 L 208 99 L 205 100 Q 202 101 203 98 L 185 93 Q 177 92 174 95 L 186 96 L 198 102 L 196 103 L 195 102 L 194 100 L 180 97 Q 173 96 170 99 L 170 100 L 175 99 L 188 102 L 188 103 L 183 102 L 168 103 L 167 105 L 172 104 L 187 107 L 185 108 L 181 106 L 173 106 L 162 110 L 163 112 L 171 109 L 174 110 L 165 112 L 159 115 L 160 117 L 166 114 Q 171 116 173 113 L 174 114 L 172 115 L 170 115 L 163 117 L 156 125 L 166 119 L 167 119 L 163 122 L 156 130 L 169 121 L 171 120 L 167 125 Q 164 130 157 132 L 157 133 Q 162 134 165 131 L 173 122 L 176 120 L 173 125 L 165 132 L 165 133 L 171 131 Q 178 126 181 117 L 183 116 L 177 127 L 171 134 L 175 132 L 183 122 L 185 121 L 182 127 L 177 133 L 180 132 Q 187 127 190 118 L 191 118 Q 189 126 183 131 L 184 132 L 186 131 L 191 125 L 198 111 L 200 110 L 192 127 L 189 130 L 190 131 Q 197 125 200 116 L 201 116 L 196 127 L 193 130 L 195 130 L 199 126 L 213 103 L 210 102 L 214 101 Q 212 112 205 119 L 207 119 Q 216 113 217 100 L 220 99 L 221 100 L 214 115 L 211 118 L 212 119 L 219 110 L 221 109 Q 219 117 213 122 L 215 122 Q 223 114 227 102 Q 228 97 224 99 L 224 101 L 223 100 L 225 98 L 234 97 L 233 94 L 227 94 L 221 96 Q 217 97 219 93 L 214 93 L 197 87 L 186 87 Z M 303 87 L 287 93 Q 279 91 281 96 L 279 95 L 268 94 L 266 97 L 276 98 L 277 101 L 276 101 Q 277 98 273 99 Q 275 114 286 122 L 287 122 Q 282 117 280 110 L 280 108 L 288 118 L 289 118 Q 283 111 280 101 L 280 99 L 283 100 L 283 105 L 288 114 L 294 118 L 286 103 Q 285 100 289 101 L 288 103 L 288 105 L 299 123 L 306 130 L 307 130 L 300 119 L 301 117 L 305 126 L 311 131 L 300 109 L 300 107 L 311 128 L 317 132 L 318 132 Q 312 127 309 119 L 310 117 L 314 126 L 323 133 L 324 133 Q 317 128 315 120 L 315 118 L 319 126 L 328 133 L 329 133 Q 321 127 318 117 L 318 115 L 325 127 L 334 133 L 336 133 L 335 132 Q 328 128 325 121 L 325 119 L 327 123 Q 331 130 340 133 L 344 133 L 337 128 L 334 125 L 330 119 L 344 130 L 345 130 L 337 122 L 334 118 L 343 125 Q 345 126 344 124 L 337 116 L 334 115 L 329 116 L 327 113 L 335 114 L 341 117 L 341 116 Q 336 110 327 110 L 327 109 L 335 110 L 338 112 L 338 110 L 328 106 Q 320 105 317 108 L 313 107 L 325 104 L 329 105 L 334 105 L 329 102 L 318 102 L 317 103 L 312 103 L 326 99 L 328 100 L 331 100 L 326 97 L 315 98 L 310 100 L 306 100 L 319 95 L 326 95 L 324 93 L 312 94 L 304 97 L 301 97 L 312 92 Q 316 93 318 91 L 320 92 L 320 90 L 310 90 L 295 95 L 293 95 L 307 89 L 316 88 L 303 87 Z M 159 96 L 150 106 L 147 113 L 148 116 L 144 122 L 142 123 L 151 102 L 151 98 L 140 117 L 140 128 L 139 130 L 137 131 Q 136 115 143 108 L 143 106 Q 136 111 134 120 Q 132 129 136 133 L 131 145 L 130 137 L 125 124 L 126 119 L 124 118 L 123 122 L 123 129 L 127 139 L 127 140 L 121 125 L 119 128 L 120 135 L 127 153 L 126 157 L 124 151 L 117 138 Q 119 131 115 132 L 113 137 L 114 149 L 123 164 L 122 168 L 120 162 L 112 148 L 110 147 L 111 152 L 110 154 Q 109 160 113 162 L 113 163 L 109 158 L 108 152 L 107 152 L 108 161 L 117 181 L 117 183 L 115 182 L 114 176 Q 107 168 104 158 L 102 159 L 104 166 L 105 167 L 103 164 L 101 163 L 102 169 L 109 181 L 109 182 L 101 171 Q 102 166 99 167 Q 99 174 103 180 L 104 181 L 101 177 L 99 176 L 100 181 L 112 200 Q 113 204 111 206 L 109 203 L 111 204 L 111 202 L 100 186 Q 101 182 98 183 L 100 191 L 100 192 L 98 189 L 97 189 L 97 194 L 101 202 Q 104 207 111 209 Q 109 210 110 215 L 109 216 L 100 204 Q 101 200 98 201 L 100 211 L 98 211 L 99 216 L 105 221 L 108 221 L 107 219 L 109 218 L 108 231 L 107 230 L 105 228 Q 99 224 97 216 L 95 217 Q 95 224 99 227 L 98 226 L 96 227 L 97 229 L 104 234 Q 109 232 107 238 Q 100 237 97 231 L 95 232 L 96 235 Q 99 239 106 241 L 107 241 L 107 251 L 110 251 L 111 252 L 111 244 L 113 243 L 114 241 Q 116 236 122 236 L 121 234 L 117 235 L 115 235 Q 117 229 124 228 L 125 226 Q 119 225 118 228 L 117 227 Q 120 220 129 219 L 130 217 Q 122 216 119 220 L 116 222 Q 121 213 134 212 L 133 210 Q 128 209 127 211 L 125 211 L 137 205 Q 139 206 138 203 Q 131 207 121 208 L 119 209 L 134 201 L 135 198 L 132 200 L 123 202 L 116 207 L 115 205 L 117 205 Q 122 199 131 197 L 133 194 L 131 195 L 129 195 L 139 190 L 141 187 L 121 194 L 117 197 L 118 193 L 140 184 L 143 180 L 137 183 L 128 185 L 126 185 L 144 179 L 147 175 Q 140 178 131 178 L 123 182 L 121 185 L 120 185 L 122 178 L 129 176 L 137 176 L 144 174 L 152 168 L 155 163 L 148 166 L 144 166 Q 154 165 158 159 L 158 157 L 153 160 L 140 162 L 131 165 L 129 166 L 135 162 L 148 158 L 150 156 Q 152 157 151 154 L 146 156 L 138 157 L 135 159 L 133 159 L 152 150 Q 154 151 153 148 L 141 152 L 138 152 L 156 145 L 158 142 L 152 144 L 150 144 L 157 141 L 160 136 L 155 139 L 141 143 L 139 144 L 145 140 L 151 133 L 148 134 L 145 136 L 154 128 L 154 125 L 150 128 L 147 130 L 152 126 L 157 117 Q 154 116 155 119 L 146 126 L 145 125 L 149 123 Q 159 116 163 103 L 158 106 L 163 100 L 162 99 L 153 110 L 151 111 L 160 97 L 159 96 Z M 341 96 L 347 108 L 348 109 L 345 106 L 337 99 L 340 103 L 339 103 L 337 103 L 343 115 L 353 123 Q 356 122 355 125 L 356 126 L 343 117 L 345 122 L 353 128 L 355 131 L 349 127 L 346 126 L 347 129 L 354 135 L 352 133 Q 349 132 350 135 L 360 142 L 360 143 L 346 139 L 342 136 Q 339 135 340 138 Q 343 142 350 143 L 350 144 L 345 142 L 342 143 L 349 147 L 362 151 L 362 152 L 349 148 L 347 149 L 353 153 L 366 157 L 367 159 L 351 154 L 349 155 L 356 159 L 370 164 L 371 166 L 365 163 Q 353 163 346 159 L 344 157 Q 341 156 342 159 Q 347 165 359 166 L 359 167 L 352 166 L 347 163 L 345 164 L 357 174 L 364 176 L 372 176 L 378 178 L 380 183 L 380 184 L 373 179 L 365 177 L 359 177 L 355 175 L 354 177 L 360 180 L 374 184 L 374 185 L 364 183 L 359 180 L 358 182 L 363 185 Q 374 188 383 195 L 383 197 L 378 193 L 361 187 L 359 188 L 371 194 L 371 195 L 369 194 L 368 196 L 381 202 Q 383 206 385 205 L 385 207 L 379 202 L 369 200 L 367 198 Q 364 197 365 200 L 380 207 L 381 209 L 364 203 L 362 204 Q 366 209 375 210 L 375 211 L 372 210 Q 366 208 367 212 L 378 215 L 385 223 L 377 217 L 370 218 L 378 221 L 384 228 L 381 226 Q 375 224 376 228 L 380 229 L 386 236 L 383 234 Q 378 233 379 236 L 383 237 L 388 243 L 389 244 L 389 252 L 392 251 L 393 251 L 393 240 L 396 241 L 399 240 L 405 233 L 405 230 L 394 239 L 393 234 L 401 232 L 404 226 L 402 226 L 405 220 L 405 215 Q 401 225 394 230 Q 391 227 392 221 L 398 220 L 403 212 Q 404 209 402 210 L 400 211 L 402 207 L 402 201 L 392 216 L 389 208 Q 387 203 391 204 L 392 204 Q 389 205 390 208 L 394 207 Q 401 203 403 194 L 403 188 L 402 190 L 401 190 L 402 188 L 402 182 Q 397 194 389 202 L 387 198 L 388 192 Q 387 197 390 199 L 401 179 L 401 174 L 400 176 L 399 176 L 401 172 L 401 167 L 391 185 L 390 185 L 399 167 L 399 162 L 397 166 L 396 166 L 398 161 Q 399 156 396 157 L 395 163 L 386 177 L 385 186 L 383 183 L 394 155 Q 395 150 392 151 L 389 162 L 387 163 L 391 154 L 389 153 L 391 149 L 390 145 L 379 167 L 377 164 L 387 147 Q 389 136 385 132 L 375 156 L 373 154 L 381 133 Q 383 126 380 125 L 379 130 L 374 141 L 373 141 L 377 130 Q 379 121 376 118 L 375 125 L 370 138 L 370 144 L 366 138 L 368 137 L 372 130 Q 374 119 370 114 Q 371 128 366 136 L 364 134 L 367 127 Q 367 116 362 111 L 358 108 L 363 121 L 363 131 L 360 127 L 361 125 L 359 114 L 350 99 L 349 99 L 358 122 L 358 123 L 355 119 L 352 116 L 353 115 Q 352 107 348 103 L 341 96 Z M 239 109 Q 235 110 236 115 L 239 116 L 242 115 L 243 113 L 242 111 L 239 109 Z M 260 109 L 257 113 L 258 115 Q 259 117 263 116 Q 265 115 264 111 Q 263 108 260 109 Z M 131 114 L 128 119 Q 127 130 131 136 L 134 137 L 131 126 L 131 114 Z M 250 125 L 242 134 L 243 135 L 258 135 L 256 131 L 250 125 Z M 233 133 L 217 136 L 193 146 L 190 150 L 194 150 Q 202 143 215 140 L 232 136 L 237 136 Q 239 131 233 133 Z M 265 133 L 263 135 L 265 136 L 282 139 L 297 144 L 307 150 Q 312 152 310 147 Q 292 136 265 133 Z M 167 141 Q 164 142 165 148 Q 166 150 172 149 Q 174 148 173 143 Q 172 140 167 141 Z M 330 141 Q 326 142 327 147 Q 328 150 334 149 L 336 146 L 335 143 Q 334 140 330 141 Z M 181 150 Q 178 151 179 157 Q 180 159 185 158 Q 188 157 187 153 Q 186 149 181 150 Z M 316 150 L 313 153 L 314 157 Q 315 159 320 158 Q 323 157 322 153 Q 321 149 316 150 Z M 253 153 L 252 154 L 244 154 L 243 156 L 246 157 L 247 159 Q 246 163 248 165 L 248 170 L 237 155 L 227 157 L 230 158 L 231 160 L 232 174 L 233 175 L 232 177 Q 233 179 230 178 L 231 181 L 232 180 L 240 180 L 241 179 L 239 177 L 236 171 L 237 165 L 244 175 Q 246 180 253 179 L 251 158 L 254 156 Q 255 152 253 153 Z M 175 161 L 172 163 Q 159 173 152 188 Q 151 192 155 190 Q 163 173 177 163 Q 178 160 175 161 Z M 324 161 L 324 164 L 328 166 Q 338 175 345 189 Q 344 192 348 190 L 348 187 L 340 175 L 328 162 L 324 161 Z M 284 162 L 278 165 L 274 175 L 276 182 L 281 186 L 291 189 L 293 185 Q 292 181 296 183 L 296 180 L 289 177 Q 287 175 286 178 Q 285 180 288 179 Q 289 183 287 184 L 280 180 Q 278 168 286 166 Q 291 165 294 168 L 297 173 L 300 169 L 291 162 L 284 162 Z M 201 167 L 194 171 L 189 179 Q 188 185 191 188 Q 193 193 200 194 Q 206 195 209 192 L 214 187 L 214 182 Q 211 181 212 184 L 206 189 L 199 188 L 194 182 L 194 177 Q 196 172 203 172 Q 204 174 205 172 L 204 169 L 201 167 Z M 310 175 L 311 180 L 299 192 L 297 192 Q 295 190 294 193 L 306 204 L 309 204 L 311 201 Q 310 198 309 200 L 303 196 L 315 183 L 318 184 L 319 181 L 310 175 Z M 177 186 L 170 195 L 174 194 L 188 206 Q 186 211 190 210 L 196 202 Q 195 199 194 201 L 191 201 L 178 191 L 179 188 L 177 186 Z M 150 194 L 140 216 L 137 235 L 140 236 L 144 214 L 152 196 Q 153 193 150 194 Z M 349 194 L 349 198 L 353 205 L 357 217 L 360 236 L 363 235 L 360 215 L 352 196 L 349 194 Z M 164 203 L 160 213 L 160 214 L 164 212 L 169 214 L 166 223 L 162 222 L 159 217 Q 155 221 154 228 L 158 226 L 174 232 L 177 237 L 181 226 Q 178 225 177 228 L 169 225 L 174 216 L 179 218 Q 183 220 180 222 L 183 223 L 186 212 L 183 214 L 165 207 L 166 205 L 164 203 Z M 310 204 L 308 206 L 312 214 Q 317 216 315 211 L 321 210 L 323 214 Q 324 218 321 219 L 316 218 L 320 228 Q 322 231 323 228 L 322 226 L 337 208 L 336 204 L 323 205 L 322 206 L 312 206 L 311 204 L 310 204 Z M 250 213 L 249 216 Q 250 218 247 217 L 248 220 L 245 220 L 250 236 L 253 237 L 259 222 L 257 220 L 257 219 Q 258 216 255 217 L 254 215 L 254 213 L 250 213 Z M 346 228 L 344 232 L 326 232 L 325 231 L 322 229 L 323 240 Q 326 241 325 239 L 327 237 Q 333 239 335 236 L 339 237 L 326 243 Q 323 242 324 247 L 326 248 L 339 252 L 330 254 Q 326 255 327 253 L 324 251 L 325 262 Q 328 263 327 261 L 332 258 L 343 257 L 344 256 L 347 258 Q 346 260 350 259 Q 348 256 349 249 L 344 249 L 332 246 L 346 238 L 348 238 L 347 236 L 347 229 L 346 228 Z M 84 237 L 82 239 L 82 247 L 83 248 L 82 251 L 84 253 L 82 254 L 82 261 L 82 263 L 86 269 L 84 267 L 82 269 L 89 278 L 89 281 L 97 287 L 106 291 L 107 289 L 107 293 L 108 294 L 90 284 L 85 278 Q 86 274 83 275 L 85 285 Q 89 290 96 292 L 109 296 L 110 300 L 111 301 L 104 296 L 92 292 L 85 287 L 86 291 Q 91 299 104 300 L 104 301 Q 93 301 89 294 Q 86 293 87 297 L 96 303 L 114 307 L 115 310 L 115 311 L 111 308 L 100 306 L 92 303 L 88 301 L 89 305 L 92 306 Q 94 307 92 309 L 93 311 L 101 316 L 114 319 L 120 319 L 121 321 L 121 322 Q 114 318 103 319 L 96 315 L 94 315 L 96 319 L 102 322 L 120 324 L 121 325 L 123 324 L 127 332 L 129 334 L 122 330 L 108 329 L 101 327 L 99 325 L 98 327 L 108 332 L 113 332 L 124 335 L 130 335 L 131 337 L 131 338 L 128 336 L 112 335 L 108 333 L 105 334 L 111 337 L 129 340 L 129 341 L 115 340 L 108 338 L 104 335 L 103 337 L 112 342 L 129 345 Q 134 347 136 344 L 138 347 L 137 346 L 118 346 L 110 343 L 108 344 Q 115 351 133 349 L 133 350 L 119 350 L 118 349 L 114 350 L 122 353 Q 132 351 138 354 L 138 355 Q 121 357 114 350 L 113 352 L 122 357 L 139 359 L 130 361 L 132 362 L 141 362 L 142 362 L 141 364 L 146 363 L 147 359 L 144 361 L 145 359 Q 146 356 144 357 L 145 355 L 145 357 L 164 376 L 155 375 L 161 374 L 159 371 L 146 371 L 132 376 L 130 379 L 144 375 L 150 376 L 139 380 L 137 383 L 152 378 L 160 378 L 161 380 L 154 382 L 154 383 L 170 382 Q 171 379 173 384 L 161 386 L 153 390 L 149 395 L 156 391 L 167 388 L 172 389 Q 158 390 150 397 L 148 400 L 159 395 L 171 392 L 177 393 Q 165 394 158 402 L 159 403 L 172 397 L 175 398 L 171 400 L 171 401 L 186 397 Q 192 398 191 396 L 191 394 L 196 398 L 182 400 L 174 407 L 175 408 L 189 402 L 194 403 Q 188 407 179 408 L 179 409 L 187 409 L 200 404 L 201 405 Q 197 409 190 409 L 191 411 L 196 411 L 204 407 L 203 409 L 204 411 L 206 410 L 210 404 L 221 406 L 221 402 L 219 401 L 219 399 L 222 400 Q 224 401 223 398 L 226 397 L 225 395 L 227 390 L 227 388 Q 222 389 223 397 L 222 397 Q 220 388 224 385 Q 225 382 223 383 Q 218 385 219 391 L 214 384 Q 216 376 212 377 L 211 381 Q 211 391 217 396 L 218 397 Q 212 393 209 385 Q 208 374 213 371 L 212 370 Q 207 373 206 379 Q 205 389 209 395 L 214 398 L 214 399 L 209 398 L 209 396 L 205 390 L 203 379 L 201 384 L 198 373 L 196 375 L 196 381 Q 196 372 193 368 Q 194 365 192 366 L 192 368 L 192 376 L 191 377 Q 191 384 194 389 L 199 392 L 200 394 L 192 390 Q 189 389 191 388 L 187 379 L 187 368 L 185 367 L 183 373 L 183 377 L 182 377 L 182 364 L 183 363 Q 184 360 182 361 Q 178 365 179 373 L 177 371 L 177 359 L 178 358 Q 179 355 176 356 L 174 362 L 174 372 L 175 373 L 175 374 L 172 371 L 169 360 L 171 349 L 169 348 Q 166 351 167 358 L 166 346 L 165 345 Q 166 341 163 342 L 162 364 L 158 356 L 158 345 L 159 344 L 159 341 Q 153 344 155 355 L 154 355 L 154 340 L 156 335 L 156 332 L 152 338 L 150 347 L 152 357 L 146 352 L 150 354 L 149 351 L 150 336 L 151 334 L 149 335 L 148 322 L 147 319 L 144 332 L 144 339 L 143 341 L 141 334 L 143 323 L 143 319 L 141 323 L 140 323 Q 139 318 141 317 Q 143 310 140 309 Q 141 305 139 306 L 139 308 Q 139 319 135 327 L 135 336 L 133 334 L 132 331 L 134 332 L 133 330 Q 132 324 135 322 Q 136 319 134 320 L 132 321 L 134 316 Q 135 313 132 314 Q 128 318 129 327 L 126 324 L 131 305 L 130 299 L 125 313 L 123 314 L 124 307 L 128 297 L 128 286 L 127 289 Q 127 283 125 280 L 124 282 L 122 275 L 121 273 L 120 279 Q 120 270 116 267 L 115 273 L 113 265 L 111 261 L 110 270 L 109 261 L 107 258 Q 105 253 104 256 L 102 254 Q 103 251 99 252 L 98 248 Q 94 249 95 247 L 84 237 Z M 417 237 L 411 241 L 405 249 L 402 248 L 401 251 Q 402 253 400 252 L 397 257 L 395 256 Q 390 260 391 269 L 390 261 Q 386 265 386 272 L 385 272 L 386 269 Q 387 266 384 267 L 381 274 L 381 278 L 380 273 L 377 279 Q 378 281 375 280 L 374 283 Q 375 287 372 286 L 372 296 L 376 307 L 378 318 L 377 320 L 376 320 L 377 318 L 372 301 L 370 300 L 370 309 L 372 313 L 374 324 L 373 326 L 371 327 L 372 325 L 369 316 L 366 314 L 368 321 L 367 320 L 365 321 L 367 325 L 367 331 L 365 330 L 365 326 L 362 317 L 362 306 L 359 312 L 361 323 L 361 325 L 359 321 L 357 320 L 359 328 Q 360 336 358 342 L 355 330 L 355 320 L 353 319 L 352 323 L 352 333 L 353 334 L 353 337 L 352 336 L 350 335 L 351 339 L 351 351 L 349 340 L 347 335 L 344 333 L 347 344 L 346 356 L 344 344 L 341 342 L 342 344 Q 344 357 339 364 L 338 364 L 339 362 L 337 342 L 334 348 Q 333 353 335 355 L 335 362 L 332 350 L 330 349 L 331 354 Q 332 367 326 375 L 325 375 L 326 373 Q 328 363 325 358 L 323 357 Q 322 361 324 363 L 323 371 Q 320 370 321 365 L 319 361 L 317 362 L 319 368 L 318 378 Q 318 369 314 366 L 313 379 L 309 387 L 309 390 L 302 393 L 300 394 L 303 392 Q 307 389 309 383 L 309 373 L 308 372 L 309 368 Q 310 365 307 366 L 305 382 L 304 375 L 303 373 L 300 384 L 299 384 Q 301 378 297 379 L 297 385 L 291 396 L 291 398 L 288 399 L 286 399 L 288 398 L 294 389 Q 296 375 290 370 L 287 371 L 291 377 Q 293 387 288 392 L 281 399 L 282 400 L 279 402 Q 278 405 281 406 L 289 404 Q 291 403 290 406 L 297 411 L 297 409 L 297 407 L 305 411 Q 312 413 311 409 L 308 409 L 300 405 L 300 404 L 313 409 L 322 409 L 307 403 L 307 402 Q 319 402 326 408 L 327 408 L 326 406 Q 319 398 305 398 L 309 395 L 309 397 Q 320 397 327 401 L 330 401 L 328 399 L 327 397 Q 336 398 342 403 L 342 402 L 331 394 L 324 393 L 324 392 L 335 393 L 352 400 Q 354 401 353 398 L 337 390 L 329 389 L 329 388 Q 343 388 352 395 L 352 394 Q 344 385 328 384 L 330 381 L 335 383 L 347 383 L 341 380 L 342 378 L 354 379 L 363 383 Q 365 384 364 381 L 354 376 L 351 376 L 351 375 Q 363 374 370 379 L 372 379 Q 362 370 342 371 Q 344 366 347 370 L 351 369 Q 354 371 361 370 L 369 373 L 371 373 L 356 366 Q 349 364 348 367 L 346 367 L 351 361 L 356 356 L 358 356 L 358 357 L 355 357 Q 356 360 353 359 L 353 362 L 357 364 Q 360 365 359 363 L 358 360 L 361 362 L 370 362 L 370 360 L 363 359 L 363 358 L 367 359 L 376 358 L 384 355 L 387 351 L 377 355 L 362 355 Q 368 351 379 353 L 386 350 L 386 349 L 382 350 L 367 350 L 381 349 L 389 347 L 391 345 Q 393 346 392 343 L 384 346 L 365 346 L 364 347 L 363 346 Q 364 343 366 345 L 382 344 L 392 341 L 396 338 Q 398 339 397 337 L 398 335 L 387 340 L 377 340 L 393 336 L 395 333 L 389 335 L 371 337 L 369 338 L 370 336 Q 371 333 373 335 L 393 332 Q 399 331 403 327 L 403 325 L 394 329 L 379 330 L 374 332 L 372 333 L 377 325 L 379 325 L 389 323 L 396 323 L 403 320 L 406 316 L 406 314 L 398 319 Q 387 318 382 321 L 379 321 Q 380 318 382 320 L 400 316 L 408 310 L 407 308 L 410 306 L 413 300 L 405 305 Q 395 306 388 309 L 385 311 L 386 309 L 398 304 L 406 303 L 411 300 L 413 297 L 412 294 L 415 290 L 415 287 L 403 295 L 393 298 L 390 300 L 391 296 L 395 296 Q 400 291 410 290 L 417 281 L 417 275 L 413 282 L 407 287 L 395 293 Q 392 292 393 295 L 392 295 L 393 291 L 395 291 L 409 284 L 411 279 L 400 284 L 395 288 L 393 285 L 396 281 L 396 283 Q 394 284 397 285 L 414 276 L 418 270 Q 419 266 417 267 L 415 268 L 418 263 L 416 263 L 419 259 L 417 253 L 418 249 L 418 247 L 418 239 L 417 237 Z M 154 239 L 151 245 Q 150 252 153 256 Q 156 260 162 261 Q 168 262 172 259 L 175 256 L 177 249 L 176 244 L 174 240 L 171 241 L 173 247 L 172 252 L 168 255 Q 161 256 158 254 L 155 251 Q 154 246 156 245 Q 155 242 158 243 L 158 240 L 154 239 Z M 139 240 L 132 245 Q 129 246 129 250 Q 133 255 139 257 L 139 240 Z M 234 240 L 232 242 L 230 254 L 227 255 L 225 258 L 217 259 L 221 268 Q 218 269 219 272 L 209 278 L 218 283 L 219 283 L 219 287 L 221 288 L 217 296 L 222 297 Q 227 296 225 300 L 229 300 L 230 302 L 234 315 L 241 310 L 247 311 L 251 315 L 253 315 L 255 312 L 258 310 Q 259 312 261 309 L 269 313 L 271 301 L 277 300 L 278 297 L 285 296 L 281 290 Q 280 286 283 287 L 283 283 L 291 278 L 283 272 Q 284 267 281 268 L 285 259 L 280 258 Q 277 259 278 257 Q 276 253 271 255 Q 269 252 270 245 L 269 242 L 261 246 Q 259 242 258 245 L 251 240 L 246 245 L 245 244 L 242 245 L 240 245 L 234 240 Z M 361 240 L 361 257 L 366 255 L 371 250 L 371 248 Q 367 242 361 240 Z M 137 261 L 138 278 L 146 303 L 150 304 L 142 281 L 140 263 L 137 261 Z M 361 261 L 357 286 L 350 303 Q 349 305 353 304 L 360 287 L 363 273 L 363 262 L 361 261 Z M 152 307 L 150 309 L 164 330 L 173 338 L 175 338 L 175 336 Q 162 324 153 309 Q 154 306 152 307 Z M 349 307 Q 338 323 325 337 Q 324 339 328 338 Q 341 326 350 310 L 349 307 Z M 252 318 L 245 333 Q 244 336 248 335 L 247 337 Q 246 339 249 338 Q 248 342 252 343 L 255 341 Q 254 338 257 339 L 256 336 L 259 334 L 252 318 Z M 181 339 L 178 342 L 179 346 Q 178 349 184 347 Q 187 346 186 341 Q 185 338 181 339 Z M 315 339 L 314 345 Q 315 348 321 347 Q 323 346 322 341 Q 320 338 315 339 Z M 188 348 L 188 351 Q 205 364 232 368 Q 238 370 236 365 L 219 362 L 206 357 L 188 348 Z M 311 348 L 288 360 L 267 365 Q 262 364 264 368 Q 295 365 313 350 Q 314 347 311 348 Z M 145 366 L 137 368 L 132 371 L 131 373 L 142 370 L 153 370 L 154 369 Q 156 370 155 367 Q 152 365 145 366 Z M 242 366 L 250 375 L 254 373 L 258 368 L 258 366 L 242 366 Z M 286 377 Q 288 386 283 390 L 281 387 L 276 383 L 279 391 L 279 394 L 277 392 L 273 389 L 275 396 Q 273 397 276 398 Q 278 399 277 397 L 278 397 L 277 399 L 279 401 L 289 387 Q 291 380 288 379 Q 289 376 286 377 Z M 248 380 L 241 385 L 234 387 L 230 392 Q 231 396 229 395 L 223 403 Q 222 409 225 412 L 228 413 L 229 415 L 230 422 L 236 426 Q 240 424 239 428 Q 242 432 248 433 L 254 433 L 263 426 L 268 424 Q 272 422 271 416 L 277 408 L 276 400 L 270 395 L 269 390 Q 266 385 260 385 L 256 381 L 248 380 Z M 214 408 L 210 412 Q 209 420 214 421 L 221 420 Q 224 418 223 412 Q 222 407 214 408 Z M 281 408 L 277 412 L 278 419 L 282 421 Q 287 422 289 420 L 291 416 L 290 411 Q 288 406 281 408 Z "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 74 L 251 78.5 L 249 77.5 L 250.5 74 Z "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 79 L 244 80.5 L 242.5 81 L 241.5 79 Z "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 84 L 243 84.5 L 239.5 85 L 239.5 84 Z "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248 84 Q 251.8 83 253 85.5 L 252.5 87 L 252 85 L 248.5 86 L 248 84 Z "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 258.5 84 L 262 84.5 L 258.5 85 L 258.5 84 Z "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 87 L 252 88.5 L 249.5 89 L 248.5 87 Z "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 90 L 239.5 92 L 240.5 90 Z "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 90 L 260.5 92 L 259.5 90 Z "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 92 L 245 93.5 L 244.5 95 L 244 93.5 L 245.5 92 Z "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 95 L 216 96.5 L 211.5 98 L 211 96 L 209.5 95 Z "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 96 Q 290.4 94 289 98 L 283.5 97 L 283.5 96 Z "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 97 L 299 97.5 L 297 98 Q 298.1 100.7 295.5 100 L 292 98.5 L 297.5 97 Z "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 100 Q 306.3 98.8 305 102.5 L 303.5 102 L 301 101.5 L 302.5 100 Z "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207 102 L 209 102.5 L 207 103.5 L 207 102 Z "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 291.5 102 Q 293.8 101.3 293 103.5 L 291.5 102 Z "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189 103 L 193 103.5 L 189 105 L 189 103 Z "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 306.5 103 Q 311.9 101.1 311 104.5 L 311.5 106 L 306.5 104 L 306.5 103 Z "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201 104 L 203 104.5 L 201 105.5 L 201 104 Z "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 104 Q 299.8 103.3 299 105.5 L 297.5 104 Z "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 106 L 197 106.5 L 194.5 110 L 194 108 L 192 107.5 L 195.5 106 Z "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 106 L 307 107.5 L 306 109.5 L 309 115.5 L 308 115.5 L 303.5 106 Z "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 108 L 155.5 110 L 156.5 108 Z "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 108 L 190 109.5 L 189.5 111 L 188.5 109 L 190.5 108 Z "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 309.5 108 L 312 109.5 L 310 110.5 L 309.5 108 Z "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 109 L 345.5 111 L 344.5 109 Z "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 110 L 179 110.5 L 175.5 113 L 175.5 110 Z "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 110 L 325 110.5 L 324.5 113 L 321.5 110 Z "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 111 L 184 112.5 L 183.5 114 L 183 112.5 L 184.5 111 Z "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 315.5 111 L 317 113.5 L 315 112.5 L 315.5 111 Z "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 346.5 112 L 348.5 115 L 346.5 112 Z "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 114 L 179 115.5 L 177 116.5 L 178.5 114 Z "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 114 L 324 115.5 Q 322.5 118.5 321 115.5 L 321.5 114 Z "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 115 L 150.5 117 L 151.5 115 Z "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 116 L 350.5 118 L 349.5 116 Z "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 130 L 144.5 132 L 145.5 130 Z "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 131 L 360 132 L 361 134.5 L 358.5 133 L 356.5 131 Z "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 132 L 143 132.5 L 139.5 135 L 141.5 132 Z "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 135 L 356.5 137 L 355.5 135 Z "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 136 L 142.5 138 L 143.5 136 Z "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 141 L 128 143.5 L 127 143.5 L 127.5 141 Z "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 142 L 373 144.5 L 372 144.5 L 372.5 142 Z "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 145 Q 131.3 146.2 129 147.5 L 128.5 149 L 128.5 145 Z "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134 145 L 136 145.5 L 133 147.5 L 134 145 Z "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 145 L 367 146.5 L 365.5 146 L 364.5 145 Z "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 371.5 146 L 372 148.5 L 371 148.5 L 371.5 146 Z "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 153 L 371 156.5 L 369 155.5 L 369.5 153 Z "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130 154 L 133 154.5 L 129.5 157 L 130 155.5 L 130 154 Z "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128 160 L 130 160.5 L 127 162.5 L 128 160 Z "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 160 L 373 161.5 L 372.5 163 L 370.5 160 Z "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 166 L 375 167 L 376 169.5 L 372.5 166 Z "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125 167 L 127 167.5 L 125 168.5 L 125 167 Z "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 186 L 381 188.5 L 379 187.5 L 380.5 186 Z "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119 187 L 121 187.5 L 119 188.5 L 119 187 Z "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 191 L 114 193.5 L 112.5 198 L 112.5 191 Z "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 399.5 194 L 398.5 196 L 399.5 194 Z "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 209 L 329 209.5 L 326 211.5 L 325.5 209 Z "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 210 Q 117.5 211.5 114.5 213 L 114.5 210 Z "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 376.5 211 L 379 212.5 L 377.5 212 L 376.5 211 Z "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 384.5 211 Q 386.8 210.3 386 212.5 L 384.5 211 Z "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391 218 L 393 218.5 L 391 219.5 L 391 218 Z "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 224 L 114 225.5 L 112.5 228 L 112 225.5 L 113.5 224 Z "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251 224 L 253 224.5 L 251 225.5 L 251 224 Z "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386 224 Q 389.3 222.7 388 227.5 L 387 227.5 L 386 224 Z "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 232 Q 390.3 233.3 389 238.5 L 388 238.5 L 387.5 232 Z "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 252 L 258 256 L 258.5 254 L 259 255.5 L 258.5 257 Q 262.9 255.5 262 258.5 L 264 258.5 L 263.5 260 L 265.5 259 L 265 260.5 Q 264.3 262.8 266.5 262 L 269 262.5 L 268.5 264 L 271.5 263 L 270.5 268 L 273 268.5 L 272.5 270 L 274 270.5 L 272 271.5 L 274.5 275 Q 282.8 274.2 287 277.5 Q 282.5 281 274 280.5 L 274.5 282 L 273 281.5 L 272 283.5 L 272.5 285 L 271 285.5 L 273 286.5 L 270 287.5 L 273 289.5 L 271 290.5 L 272.5 293 L 268.5 291 L 265 293 L 266 295.5 L 264.5 295 L 263 295.5 L 263.5 297 L 262 296.5 L 263 299.5 L 260.5 298 L 259 299.5 L 258.5 301 L 258 299 L 256 299.5 L 257 302.5 L 256 302.5 Q 257.1 299.2 254.5 300 L 251.5 302 L 247.5 299 L 245.5 302 L 244.5 299 L 243.5 301 L 243 299.5 L 244 297.5 L 239 298.5 L 240 296.5 L 236 298.5 L 238 295.5 L 236 295.5 L 237 293.5 L 235.5 293 L 234 293.5 L 234.5 292 L 232.5 293 L 233.5 290 L 231.5 291 L 231.5 289 L 229.5 290 L 230.5 288 L 232 287.5 L 229 286.5 L 232 284.5 L 229 283.5 L 229.5 280 L 228 279.5 L 228.5 278 L 218 277.5 L 229 276.5 L 227 275.5 L 230 274.5 L 229.5 271 L 232 270.5 L 229 268.5 L 232 267.5 L 229 265.5 L 230.5 266 L 232 265.5 L 231.5 264 L 233.5 265 L 232.5 262 L 235 263.5 L 234 261.5 L 235.5 262 L 237 261.5 L 236 259.5 L 237.5 257 L 240 258.5 L 238 255.5 L 244 257.5 L 243 254.5 L 244 254.5 L 244.5 256 L 245.5 253 L 247.5 256 L 251 253.5 L 251.5 252 Z M 249 259 L 240 263 Q 233 267 233 277 L 233 279 Q 233 286 237 290 L 248 296 Q 256 297 261 294 Q 268 289 270 280 Q 270 272 267 268 Q 263 258 249 259 Z "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 263 L 256.5 263 L 264 269.5 L 267 277.5 Q 265.3 286.8 258.5 291 L 249.5 293 Q 241.4 291.6 238 285.5 Q 235.1 281.9 236 274.5 Q 237.5 268 242.5 265 L 246.5 263 Z M 251 265 L 247 268 L 239 277 L 239 279 L 245 287 Q 249 286 251 290 L 254 289 L 257 287 L 264 278 L 258 269 Q 254 270 255 268 Q 255 264 251 265 Z "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 271 L 392 274.5 L 391 274.5 L 391.5 271 Z "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 273 L 109 275.5 L 108 275.5 L 108.5 273 Z "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 273 L 387 275.5 L 386 275.5 L 386.5 273 Z "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 278 L 104.5 285 L 105.5 283 L 107.5 286 L 106 285.5 L 105.5 288 L 102.5 285 L 92.5 281 L 90.5 278 Z "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 392.5 286 L 392 287.5 L 391.5 289 L 391 287.5 L 392.5 286 Z "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 293 L 112 295.5 L 111 295.5 L 110.5 293 Z "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 293 L 383 300.5 L 382 300.5 L 380.5 293 Z "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 410.5 294 L 407.5 298 L 400.5 300 L 400.5 299 L 410.5 294 Z "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 298 Q 115.1 297.2 114 300.5 L 113 300.5 L 112.5 298 Z "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386 298 L 388 298.5 L 386.5 301 L 386 298 Z "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 299 L 118 301.5 L 117 301.5 L 117.5 299 Z "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 396.5 300 L 399 300.5 L 394.5 302 L 394.5 301 L 396.5 300 Z "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 301 L 112 303.5 L 113 305.5 L 110.5 304 L 105.5 302 L 105.5 301 Z "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 301 L 393 302.5 L 388.5 305 L 388 303.5 L 389.5 301 Z "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 304 Q 118.1 303.2 117 306.5 L 116 306.5 L 115.5 304 Z "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 383 304 L 385 304.5 L 383.5 307 L 383 304 Z "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 309 Q 383.2 310.3 381 311.5 L 380.5 313 L 380 311.5 L 380.5 309 Z "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 310 Q 121.1 309.2 120 312.5 L 119 312.5 L 118.5 310 Z "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 313 Q 117.8 311.9 117 314.5 L 118.5 317 L 114.5 313 Z "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 384.5 313 L 386 313.5 L 382.5 316 L 384.5 313 Z "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 317 Q 124.8 316.3 124 318.5 L 122.5 317 Z "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 366 332 L 368 332.5 L 365.5 336 L 365 334.5 L 366 332 Z "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 339 Q 140.1 338.2 139 341.5 L 139.5 343 L 137.5 339 Z "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361 339 L 363 339.5 L 361.5 342 L 361 339 Z "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 340 L 376 340.5 L 372.5 341 L 372.5 340 Z "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 341 L 135 342.5 L 133.5 342 L 132.5 341 Z "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142 345 Q 145 343.8 144 347.5 L 144.5 349 L 142 345 Z "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 357.5 345 L 358 346.5 L 356 347.5 L 357.5 345 Z "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 349 L 140.5 351 Q 137.7 351.7 139.5 349 Z "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 349 L 361.5 351 Q 358.7 351.7 360.5 349 Z "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 353 L 349.5 356 L 349 354 L 351.5 353 Z "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 359 L 345 360.5 L 343 361.5 L 344.5 359 Z "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 363 L 167 365.5 L 166 365.5 L 166.5 363 Z "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 365 L 167 371.5 L 161 366.5 L 162.5 365 Z "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 337 366 L 339 366.5 L 335 369.5 L 337 366 Z "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 373 L 170.5 375 L 169.5 373 Z "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 338.5 373 L 346 374.5 L 337.5 375 L 336.5 376 L 338.5 373 Z "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 376 L 174.5 377 L 176 376.5 L 178 379.5 L 176.5 380 L 172.5 376 Z "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 376 Q 328 378 323.5 380 L 323 378.5 L 324.5 376 Z "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 334.5 377 L 335 379 L 333 378.5 L 334.5 377 Z "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 382 L 197 384.5 L 196 384.5 L 196.5 382 Z "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 384 L 188.5 388 L 185 385.5 L 185.5 384 Z "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 386 L 179 387.5 L 173.5 388 L 173.5 387 L 176.5 386 Z "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 323.5 386 L 327 387.5 L 321.5 388 L 321.5 387 L 323.5 386 Z "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 390 L 185 391.5 L 178.5 392 L 178.5 391 L 182.5 390 Z "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 317.5 390 L 322 391.5 L 313.5 393 L 313.5 392 L 317.5 390 Z "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 391 L 252.5 396 Q 254 393.5 255.5 397 Q 257.8 396.3 257 398.5 L 260 400 Q 258.3 404.5 263.5 403 L 263.5 404 Q 260.2 402.9 261 405.5 Q 263.5 407 260 408.5 L 258 412.5 L 258.5 414 Q 254.8 413 256 416 L 253.5 416 L 251 416.5 L 250.5 424 L 248.5 416 L 246.5 416 L 244.5 417 L 243.5 414 Q 241.3 414.8 242 412.5 L 244.5 414 L 253.5 415 L 258 411.5 L 259 403.5 L 255.5 399 L 248.5 397 L 242 401.5 L 241 408.5 L 242 411 Q 239 412.3 240 408.5 L 239 406.5 Q 241.3 405.3 238.5 404 L 236 403.5 L 241 401.5 L 240.5 400 L 243 398.5 L 242 396.5 L 243.5 397 Q 247.3 398.3 246 394.5 L 247 394.5 L 247.5 396 L 250.5 391 Z "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 393 L 299 395 L 295.5 396 L 295.5 395 L 298.5 393 Z "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 394 L 205 395.5 L 203.5 395 Q 200.5 395.5 201.5 394 Z "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 399 L 202 400.5 L 199 401 L 199.5 399 Z "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 400 L 301 400.5 L 298.5 401 L 298.5 400 Z "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 402 L 209 403.5 L 207.5 404 L 205.5 402 Z "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 402 L 295 402.5 L 291.5 404 L 291.5 403 L 293.5 402 Z "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 403 L 254 405.5 Q 254.5 409.5 251.5 410 Q 246.8 410.8 246 407.5 L 247 404 L 249.5 403 Z "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228 404 Q 231.3 402.9 230 407 Q 226.7 408.1 228 404 Z "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 271.5 404 Q 274.5 405.5 271.5 407 Q 268.5 405.5 271.5 404 Z "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 291.5 68 L 291 69.5 Q 291.8 71.8 289.5 71 L 291.5 68 Z "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 69 L 211 71.5 L 210 71.5 L 209.5 69 Z "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 72 L 280.5 74 L 278 73.5 L 279.5 72 Z "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 73 L 220.5 75 L 219.5 73 Z "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 73 L 287.5 75 L 288.5 73 Z "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 75 Q 215.7 79.2 218 77.5 L 217.5 80 L 213.5 75 Z "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 75 L 238 76.5 L 236 77.5 L 237.5 75 Z "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 75 L 264 77.5 L 262 76.5 L 262.5 75 Z "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 76 L 282.5 78 L 283.5 76 Z "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 77 L 297.5 79 L 298.5 77 Z "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 78 L 215 80.5 L 212.5 79 L 211.5 78 Z "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 78 L 248 79.5 L 247.5 82 L 246 80.5 L 246.5 78 Z "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 275.5 78 L 274.5 80 L 275.5 78 Z "
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 78 L 289 78.5 L 284.5 82 L 287.5 78 Z "
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 79 L 250.5 81 L 249.5 79 Z "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 79 L 281.5 81 L 282.5 79 Z "
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 83 L 242 83.5 L 239.5 84 L 239.5 83 Z "
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 83 L 252.5 85 L 251.5 83 Z "
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 258.5 83 L 261 83.5 L 258.5 84 L 258.5 83 Z "
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 84 L 261.5 86 L 260 85.5 L 262.5 84 Z "
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 86 L 209.5 88 L 208.5 86 Z "
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 86 L 244.5 88 Q 241.7 88.7 243.5 86 Z "
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 86 L 250.5 88 L 249 87.5 L 251.5 86 Z "
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 86 L 259 87.5 L 257.5 87 L 256.5 86 Z "
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 88 L 310 88.5 L 307.5 89 L 307.5 88 Z "
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186 90 L 190 90.5 L 186.5 92 L 186 90 Z "
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 90 Q 242.5 91.5 239.5 93 L 238 92.5 L 240 91.5 L 239.5 90 Z "
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 315.5 90 L 319 90.5 L 313.5 92 L 313.5 91 L 315.5 90 Z "
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 91 L 244.5 93 L 245.5 91 Z "
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 91 L 249.5 93 L 250.5 91 Z "
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 91 Q 257.5 92.5 254.5 94 L 254.5 91 Z "
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 91 L 262 91.5 Q 259.9 94.8 259.5 91 Z "
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 93 L 183 93.5 Q 180.9 95.9 175.5 95 L 175.5 94 L 178.5 93 Z "
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 93 L 217 93.5 L 214.5 94 L 214.5 93 Z "
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 93 L 286 93.5 L 283.5 94 L 283.5 93 Z "
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 93 Q 324.3 91.7 323 95 Q 319.2 95.8 319.5 93 Z "
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 94 Q 235.5 95.5 232.5 97 L 232.5 94 Z "
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 291.5 94 L 294 95.5 L 292.5 96 L 291.5 94 Z "
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 95 L 219 96.5 L 217.5 97 L 216.5 95 Z "
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 95 L 281.5 97 L 282.5 95 Z "
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 97 L 211 98.5 L 209.5 99 L 207.5 97 Z "
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 290.5 97 L 296 97.5 L 289.5 99 L 290.5 97 Z "
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 341.5 97 L 342.5 99 L 341.5 97 Z "
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 98 L 171.5 100 L 170 99.5 L 172.5 98 Z "
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 98 L 261.5 100 L 262.5 98 Z "
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 98 Q 279.8 97.3 279 99.5 L 277.5 98 Z "
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 98 L 330 99.5 L 328.5 100 L 327.5 98 Z "
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 99 L 151 100.5 L 149 101.5 L 150.5 99 Z "
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 99 L 180 99.5 L 177.5 100 L 177.5 99 Z "
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 99 L 203.5 101 L 202.5 99 Z "
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 338.5 99 L 341.5 103 L 339 102 L 338.5 99 Z "
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 100 L 155.5 103 L 154.5 102 L 152 103.5 L 155.5 100 Z "
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 100 L 245 102.5 L 242.5 101 L 241.5 100 Z "
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257.5 100 L 260 100.5 L 256.5 102 L 257.5 100 Z "
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 343.5 100 L 344.5 102 L 343.5 100 Z "
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 290.5 101 L 292 101.5 L 288.5 104 L 290.5 101 Z "
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 102 L 181 102.5 L 173.5 103 L 173.5 102 Z "
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 102 L 195 103.5 L 193.5 103 L 192.5 102 Z "
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 102 L 325 102.5 L 320.5 103 L 320.5 102 Z "
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 103 L 163 103.5 L 160 105.5 L 160.5 107 L 158.5 104 Q 160 106.5 161.5 103 Z "
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 103 L 168.5 105 L 167 104.5 L 169.5 103 Z "
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 103 L 315 103.5 L 312.5 104 L 312.5 103 Z "
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 103 L 334 104.5 L 331 105 L 331.5 103 Z "
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 104 L 148.5 106 L 147.5 104 Z "
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 104 L 201 106.5 L 199 105.5 L 199.5 104 Z "
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 104 L 222.5 106 L 221.5 104 Z "
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 104 L 322 104.5 L 319.5 105 L 319.5 104 Z "
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 105 L 155.5 107 L 156.5 105 Z "
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 105 Q 188.9 103.5 188 106.5 L 186.5 106 Q 183.5 106.5 184.5 105 Z "
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 313.5 105 L 316 105.5 L 313.5 106 L 313.5 105 Z "
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 106 L 221.5 108 L 220.5 106 Z "
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 106 L 278.5 108 L 279.5 106 Z "
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 107 L 142 109 L 140 108.5 L 141.5 107 Z "
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300.5 107 L 299.5 109 L 300.5 107 Z "
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 107 Q 349 109 344.5 111 L 345.5 107 Z "
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 107 L 360.5 110 Q 358.3 110.8 359 108.5 L 358.5 107 Z "
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 108 L 156.5 110 L 155.5 108 Z "
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 108 L 167.5 110 Q 164.7 110.7 166.5 108 Z "
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 108 L 334 110 L 331 109.5 L 333.5 108 Z "
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 109 L 163.5 111 L 164.5 109 Z "
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 109 L 199.5 111 L 198.5 109 Z "
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 110 L 153.5 113 L 155 112.5 Q 153 116 151 111.5 L 152.5 110 Z "
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 110 L 217.5 112 L 216.5 110 Z "
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 110 L 282.5 112 L 283.5 110 Z "
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 111 L 139.5 113 L 138.5 111 Z "
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 111 L 193.5 113 L 192.5 111 Z "
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 111 L 237 113.5 L 236 113.5 L 236.5 111 Z "
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 112 L 175.5 114 L 174.5 112 Z "
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 112 L 324.5 114 L 325.5 112 Z "
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 112 L 351 112.5 L 348.5 114 L 349.5 112 Z "
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 113 L 333 113.5 L 330.5 114 L 330.5 113 Z "
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 114 L 148.5 116 L 147.5 114 Z "
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 115 L 131 117.5 L 130.5 124 L 129 116.5 L 130.5 115 Z "
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 115 Q 153.5 116.5 150.5 118 L 150.5 115 Z "
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 115 L 150.5 121 L 155.5 115 Z "
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 115 L 214 117 L 212 116.5 L 213.5 115 Z "
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 285.5 115 L 288 116.5 L 286.5 117 L 285.5 115 Z "
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318.5 115 L 317.5 117 L 318.5 115 Z "
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 115 L 325.5 118 L 327.5 115 Z "
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 115 L 370.5 117 Q 367.7 117.7 369.5 115 Z "
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 116 L 206.5 118 L 207.5 116 Z "
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 116 L 313.5 118 L 314.5 116 Z "
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 116 L 348.5 120 L 345.5 116 Z "
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 116 L 351.5 119 Q 353.8 118.3 353 120.5 L 349 117.5 L 350.5 116 Z "
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 117 L 170.5 119 L 169.5 117 Z "
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 117 L 175 117.5 L 173.5 121 L 172.5 117 Z "
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 117 L 329.5 119 L 330.5 117 Z "
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 337.5 117 L 338.5 119 L 337.5 117 Z "
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 118 L 162 120.5 L 160.5 122 L 158 121.5 L 161.5 118 Z "
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 119 L 217 119.5 L 214.5 121 L 215.5 119 Z "
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 284.5 119 L 285.5 121 L 284.5 119 Z "
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 119 L 326.5 121 L 325.5 119 Z "
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 354.5 119 L 355.5 121 L 354.5 119 Z "
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 375.5 119 L 377 122.5 L 375 123.5 L 375.5 119 Z "
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 120 L 147.5 123 L 145.5 124 L 146 122.5 L 147.5 120 Z "
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 120 L 164.5 122 L 165.5 120 Z "
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 120 L 196.5 122 L 195.5 120 Z "
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 304.5 120 L 303.5 122 L 304.5 120 Z "
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 334.5 120 L 335.5 122 L 334.5 120 Z "
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 121 L 153.5 123 L 154.5 121 Z "
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 341.5 121 L 342.5 123 L 341.5 121 Z "
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 122 L 124 126.5 L 123 126.5 L 123.5 122 Z "
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 122 L 190.5 124 L 189.5 122 Z "
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 122 L 195.5 124 L 194.5 122 Z "
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 122 L 199.5 124 L 198.5 122 Z "
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 310.5 122 L 309.5 124 L 310.5 122 Z "
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 122 L 350.5 124 L 349.5 122 Z "
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 122 L 355 122.5 L 352.5 123 L 352.5 122 Z "
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 122 L 357.5 124 L 358.5 122 Z "
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 122 L 370 125.5 L 369 125.5 L 369.5 122 Z "
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 123 L 349.5 126 L 347.5 123 Z "
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 363.5 123 L 364 131.5 L 363 131.5 L 363.5 123 Z "
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 124 L 129 127.5 L 128 127.5 L 128.5 124 Z "
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 124 L 189.5 126 L 188.5 124 Z "
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 125 L 304.5 128 Q 306.8 127.3 306 129.5 L 302 126.5 L 303.5 125 Z "
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 126 L 159 127.5 L 156.5 129 L 158.5 126 Z "
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 126 L 176.5 128 L 177.5 126 Z "
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 126 L 186.5 128 L 187.5 126 Z "
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 126 L 190.5 130 L 191 128.5 Q 190.3 126.3 192.5 127 L 193.5 126 Z "
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 126 L 194.5 130 L 194 128.5 L 197.5 126 Z "
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 126 L 253.5 129 L 251.5 126 Z "
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 306.5 126 L 311 129.5 L 309.5 130 L 306.5 126 Z "
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 341.5 126 L 343.5 129 L 341 127.5 L 341.5 126 Z "
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 379.5 126 Q 381.8 126.8 381 130.5 L 380 130.5 L 379.5 126 Z "
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 127 L 152 129.5 L 150.5 131 L 150 128.5 L 151.5 127 Z "
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 127 L 163.5 131 Q 160 129 164.5 127 Z "
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 127 L 184 127.5 L 180 130.5 Q 183.1 128.8 181.5 127 Z "
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 127 L 319 127.5 L 318.5 130 L 316.5 127 Z "
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 130 L 168.5 132 L 169.5 130 Z "
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 130 L 244.5 132 L 245.5 130 Z "
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 315.5 130 L 316.5 132 L 315.5 130 Z "
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 339.5 130 L 341 132.5 L 340 132.5 L 339.5 130 Z "
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 131 L 167 133 L 165 132.5 L 166.5 131 Z "
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 131 L 173 133 L 171 132.5 L 172.5 131 Z "
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 131 L 328.5 133 Q 325.7 133.7 327.5 131 Z "
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 131 L 334.5 133 Q 331.7 133.7 333.5 131 Z "
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 133 L 150 134.5 L 146.5 138 L 145 136.5 L 148 135.5 L 149.5 133 Z "
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 133 L 237 134.5 L 234.5 136 L 234.5 135 L 236 134.5 Q 232.7 134.6 233.5 133 Z "
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 133 L 267 133.5 L 264.5 134 L 264.5 133 Z "
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 134 L 255 134.5 L 245.5 135 L 245.5 134 Z "
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 134 L 356.5 136 L 355.5 134 Z "
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 135 L 143.5 138 Q 140.5 136.5 143.5 135 Z "
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 135 L 352.5 137 L 353.5 135 Z "
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 137 L 114 139.5 L 113 139.5 L 113.5 137 Z "
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 137 L 361 139.5 L 360 139.5 L 359.5 138 L 358 138.5 L 359.5 137 Z "
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 140 L 363.5 142 L 364.5 140 Z "
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 142 L 114 144.5 L 113 144.5 L 113.5 142 Z "
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 142 L 116 144.5 L 115 144.5 L 115.5 142 Z "
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 143 Q 136.8 142.3 136 144.5 L 134.5 143 Z "
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 143 L 138.5 145 L 137.5 143 Z "
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 143 L 328 145.5 L 327 145.5 L 327.5 143 Z "
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 143 L 361.5 145 L 362.5 143 Z "
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 371.5 143 L 372 144.5 L 369.5 146 L 371.5 143 Z "
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 384.5 143 L 385 146 L 383 145.5 L 384.5 143 Z "
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 144 L 147.5 146 L 146.5 144 Z "
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 144 L 363.5 146 L 364.5 144 Z "
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 145 L 360 146.5 L 356 147 L 356.5 145 Z "
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 146 L 117.5 148 L 116.5 146 Z "
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 146 L 373 149.5 L 372 149.5 L 372.5 146 Z "
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 147 L 133.5 149 L 132.5 147 Z "
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 147 L 191 148.5 L 190.5 150 L 190 148.5 L 191.5 147 Z "
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 148 L 110.5 150 L 111.5 148 Z "
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 149 L 128.5 151 L 126.5 152 L 127 150.5 L 127.5 149 Z "
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 149 L 150.5 151 L 149.5 149 Z "
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 149 L 382 150.5 L 380.5 153 L 380 151.5 L 381.5 149 Z "
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 150 L 113.5 152 L 112.5 150 Z "
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 150 L 185.5 152 L 184.5 150 Z "
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 315.5 150 L 314.5 152 L 315.5 150 Z "
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 150 L 320.5 152 L 319.5 150 Z "
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 151 L 108 153.5 L 107 153.5 L 107.5 151 Z "
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 151 L 139 152.5 L 137.5 153 L 136.5 151 Z "
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 152 L 134 154.5 L 132.5 154 L 130.5 152 Z "
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 152 L 135.5 154 L 134.5 152 Z "
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 152 L 364.5 154 L 365.5 152 Z "
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 392.5 152 L 393 154.5 L 392 154.5 L 392.5 152 Z "
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 154 L 111.5 156 L 110 155.5 L 112.5 154 Z "
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 154 L 126 158.5 L 124 159 L 124.5 154 Z "
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 154 L 249 154.5 L 244.5 155 L 244.5 154 Z "
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 154 Q 351.8 153.3 351 155.5 L 349.5 154 Z "
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 155 L 108.5 157 Q 105.7 157.7 107.5 155 Z "
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 155 L 148.5 157 L 147.5 155 Z "
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 155 L 237 156.5 L 235.5 156 L 234.5 155 Z "
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 155 L 369.5 157 L 368.5 155 Z "
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 156 L 112.5 158 L 113.5 156 Z "
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 156 L 184.5 158 L 183 157.5 L 185.5 156 Z "
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 157 L 131.5 161 L 128.5 157 Z "
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 157 L 379.5 159 L 380.5 157 Z "
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 157 L 389 158.5 L 387.5 158 L 386.5 157 Z "
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 158 L 108.5 160 L 109.5 158 Z "
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 158 L 344.5 161 Q 341.5 159.5 344.5 158 Z "
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 159 L 155.5 161 L 156.5 159 Z "
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 159 L 239.5 161 L 238.5 159 Z "
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 385 159 L 388 160.5 L 384 161.5 L 385 159 Z "
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 160 L 115.5 162 L 114.5 160 Z "
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 160 L 123.5 162 L 124.5 160 Z "
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 375.5 160 Q 378.1 159.2 377 162.5 L 376 162.5 L 375.5 160 Z "
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 161 L 173.5 163 L 174.5 161 Z "
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 161 Q 372.3 164.1 374 162.5 L 372.5 164 L 370.5 161 Z "
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 162 L 112.5 164 L 113.5 162 Z "
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 285.5 162 L 289 162.5 L 285.5 163 L 285.5 162 Z "
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 163 L 102.5 165 Q 99.7 165.7 101.5 163 Z "
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 163 L 174.5 165 L 175.5 163 Z "
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 163 L 242.5 165 L 241.5 163 Z "
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 398.5 163 L 399 166 L 397 165.5 L 398.5 163 Z "
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 164 L 236 167.5 L 235 167.5 L 235.5 164 Z "
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 164 L 252 166.5 L 251 166.5 L 251.5 164 Z "
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 164 L 336.5 172 L 329.5 164 Z "
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 346.5 164 Q 348.8 163.3 348 165.5 L 350 165.5 L 349 166.5 L 352.5 171 L 346.5 164 Z "
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 165 L 289 165.5 L 286.5 166 L 286.5 165 Z "
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 373 165 L 375 165.5 L 373 167.5 L 374.5 170 Q 370.2 168.3 373 166.5 L 373 165 Z "
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 166 L 102.5 168 L 103.5 166 Z "
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 166 L 115.5 168 L 114.5 166 Z "
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 166 L 140.5 168 L 138 167.5 L 139.5 166 Z "
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 166 L 239.5 168 L 238.5 166 Z "
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 166 L 277.5 168 L 278.5 166 Z "
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 166 L 362 168 L 359 167.5 L 361.5 166 Z "
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 167 L 103.5 170 L 105.5 167 Z "
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 167 L 233 170.5 L 232 170.5 L 232.5 167 Z "
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 167 L 245.5 169 L 244.5 167 Z "
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 167 L 294.5 169 L 293.5 167 Z "
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 167 L 333.5 172 L 329.5 167 Z "
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 396.5 167 L 397.5 169 L 396.5 167 Z "
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 168 L 147.5 171 L 149.5 168 Z "
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 168 L 249 171.5 L 248 171.5 L 248.5 168 Z "
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 400.5 168 L 401 169.5 L 399 170.5 L 400.5 168 Z "
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 170 L 142 170.5 L 137.5 172 L 138.5 170 Z "
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 170 L 362.5 172 L 361.5 170 Z "
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 171 Q 108.8 170.3 108 172.5 L 106.5 171 Z "
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 171 L 119.5 173 L 120.5 171 Z "
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 171 L 243.5 173 L 242.5 171 Z "
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 171 L 369 172.5 L 367.5 173 L 365.5 171 Z "
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 173 L 163.5 176 L 165.5 173 Z "
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 174 L 120 176 L 118 175.5 L 119.5 174 Z "
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 174 L 253 176.5 L 252 176.5 L 252.5 174 Z "
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 174 L 381.5 176 L 380.5 174 Z "
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 397.5 174 L 398.5 176 L 397.5 174 Z "
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 175 L 134 175.5 L 131.5 176 L 131.5 175 Z "
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 311.5 175 L 312.5 177 L 310 176.5 L 311.5 175 Z "
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 175 L 368 175.5 L 365.5 176 L 365.5 175 Z "
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 400.5 175 L 401 178 L 399 177.5 L 400.5 175 Z "
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 176 L 146 176.5 Q 143.9 179.8 143.5 176 Z "
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 176 L 247.5 178 L 246.5 176 Z "
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 337.5 176 L 338.5 178 L 337.5 176 Z "
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 377.5 176 L 378.5 178 L 376 177.5 L 377.5 176 Z "
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 177 L 363 177.5 L 360.5 178 L 360.5 177 Z "
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 177 Q 386 179 382.5 181 L 381.5 177 Z "
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 178 L 318.5 183 L 314.5 178 Z "
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 179 L 190 181.5 L 189 181.5 L 189.5 179 Z "
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 179 L 236 179.5 L 233.5 180 L 233.5 179 Z "
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 396.5 179 L 397.5 181 L 396.5 179 Z "
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 180 L 101.5 182 L 102.5 180 Z "
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 310.5 180 L 309.5 182 L 310.5 180 Z "
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140 181 L 142 181.5 L 140 182.5 L 140 181 Z "
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 182 L 279.5 185 L 277.5 182 Z "
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 182 L 295 182.5 L 292.5 184 L 293.5 182 Z "
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 182 L 316 182.5 L 308.5 189 L 314.5 182 Z "
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 390.5 182 L 391.5 184 L 390.5 182 Z "
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 183 L 99.5 185 Q 96.7 185.7 98.5 183 Z "
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 183 L 137 184.5 L 135.5 184 L 134.5 183 Z "
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 183 L 366 183.5 L 363.5 185 L 364.5 183 Z "
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 183 L 381 184.5 L 378 186.5 L 380.5 183 Z "
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 183 L 402 186.5 L 400 185.5 L 401.5 183 Z "
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 184 L 121 186.5 L 120 186.5 L 119.5 184 Z "
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 184 L 390.5 186 L 389.5 184 Z "
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 186 L 110.5 188 L 111.5 186 Z "
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 186 L 197.5 188 L 196.5 186 Z "
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 187 L 99.5 189 L 100.5 187 Z "
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 187 L 209.5 191 L 212.5 187 Z "
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 187 L 362.5 190 L 360.5 187 Z "
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 187 L 382 188.5 Q 380.5 191.5 379 188.5 L 381 188.5 L 381.5 187 Z "
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 384.5 187 Q 386.8 186.3 386 188.5 L 384.5 187 Z "
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 388.5 187 L 389.5 189 L 388.5 187 Z "
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114 188 L 116 188.5 L 114 189.5 L 114 188 Z "
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 188 L 195.5 192 L 192.5 188 Z "
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 189 L 112 190.5 L 111.5 192 L 111 190.5 L 112.5 189 Z "
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 190 L 178.5 192 L 177.5 190 Z "
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 190 L 389 192.5 L 388 192.5 L 387.5 191 L 385.5 192 L 385.5 191 L 387.5 190 Z "
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381 191 Q 384 190 383 193 Q 380 194 381 191 Z "
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 191 L 402.5 193 L 401.5 191 Z "
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117 192 L 119 192.5 L 117 193.5 L 117 192 Z "
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 193 L 296.5 195 L 295.5 193 Z "
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 194 L 370.5 197 L 370 195 L 372.5 194 Z "
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 398.5 194 L 399.5 196 L 398.5 194 Z "
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 195 L 101.5 197 L 102.5 195 Z "
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 195 L 126 197 L 124 196.5 L 125.5 195 Z "
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 195 L 184.5 197 L 183.5 195 Z "
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 374.5 195 L 375.5 197 Q 372.7 197.7 374.5 195 Z "
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 197 L 105.5 202 L 103 199.5 L 103.5 197 Z "
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 197 L 180.5 199 L 179.5 197 Z "
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 393.5 197 L 392.5 199 L 393.5 197 Z "
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 198 L 368 199 L 367.5 201 L 365.5 198 Z "
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 199 L 109.5 201 L 108.5 199 Z "
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 199 L 189.5 201 L 188.5 199 Z "
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 383.5 199 L 385 202.5 L 384 202.5 L 383.5 199 Z "
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 200 L 116 201.5 L 115.5 203 L 115 201.5 L 116.5 200 Z "
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 200 L 131.5 202 L 130.5 200 Z "
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 201 L 185.5 203 L 184.5 201 Z "
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98 202 L 100 202.5 L 98 203.5 L 98 202 Z "
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 202 L 382.5 204 L 381.5 202 Z "
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 397.5 202 L 396.5 204 L 397.5 202 Z "
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 202 L 402 204.5 L 401.5 206 L 400 203.5 L 401.5 202 Z "
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 203 L 105.5 206 L 103.5 203 Z "
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 332.5 204 L 335 204.5 L 332.5 205 L 332.5 204 Z "
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 205 L 133.5 207 L 132.5 205 Z "
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 205 L 327 205.5 L 324.5 206 L 324.5 205 Z "
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 205 L 383.5 207 L 382.5 205 Z "
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 394.5 205 L 393.5 207 L 394.5 205 Z "
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 206 L 116 208.5 L 114 207.5 L 114.5 206 Z "
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 317.5 206 L 320 206.5 L 317.5 207 L 317.5 206 Z "
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 206 L 372 206.5 L 369.5 208 L 370.5 206 Z "
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 208 L 327 208.5 L 324.5 210 L 325.5 208 Z "
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 209 L 390 211.5 L 389 211.5 L 389.5 209 Z "
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 210 L 101 210.5 L 98 212.5 L 98.5 210 Z "
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 210 Q 118.5 211.5 115.5 213 L 115.5 210 Z "
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 210 L 126 211.5 L 124.5 212 L 123.5 210 Z "
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 210 Q 132.3 209.3 133 211.5 L 131.5 211 Q 127.5 211.8 128.5 210 Z "
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 328.5 210 L 326.5 213 L 325.5 211 Q 327 213.5 328.5 210 Z "
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 210 L 332.5 212 L 333.5 210 Z "
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 210 L 386 212.5 L 386.5 211 L 387 212.5 L 385.5 214 L 382.5 210 Z "
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 211 L 122.5 213 L 121.5 211 Z "
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 378.5 211 L 377.5 213 L 378.5 211 Z "
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 212 L 315 212.5 Q 312.9 215.8 312.5 212 Z "
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 212 L 379.5 214 L 380.5 212 Z "
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 394.5 213 L 392.5 216 L 394.5 213 Z "
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 214 L 102.5 216 L 101.5 214 Z "
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 214 L 249.5 216 L 250.5 214 Z "
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 398.5 214 L 396.5 217 L 395 216.5 L 398.5 214 Z "
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 215 L 384.5 218 L 382.5 215 Z "
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 390.5 215 L 391 217.5 L 390 217.5 L 390.5 215 Z "
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 216 L 103.5 220 L 100.5 216 Z "
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 216 L 114.5 218 L 115.5 216 Z "
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 216 L 119.5 218 L 120.5 216 Z "
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 404.5 216 L 405 218.5 L 403 217.5 L 404.5 216 Z "
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 217 L 130 217.5 L 127.5 219 L 128.5 217 Z "
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 217 L 159.5 219 L 158.5 217 Z "
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247 217 L 250.5 219 L 251.5 217 Q 256.3 219.3 252 221.5 L 254 224.5 L 252.5 224 Q 249.9 224.8 251 221.5 L 252.5 219 L 250.5 220 Q 248.8 216.9 247 218.5 L 247 217 Z "
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 322.5 217 L 321.5 219 L 322.5 217 Z "
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 217 L 326.5 219 L 327.5 217 Z "
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 374.5 217 L 376 217.5 L 372.5 219 L 372.5 218 L 374.5 217 Z "
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 218 L 388 221 L 386 220.5 L 387.5 218 Z "
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 219 L 113 221.5 L 112 221.5 L 112.5 219 Z "
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 220 L 258 220.5 L 254.5 222 L 254.5 221 L 256.5 220 Z "
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 220 L 385 221.5 L 382.5 222 L 381.5 220 Z "
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 378.5 221 L 379.5 223 L 378.5 221 Z "
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 222 L 116.5 227 L 120.5 222 Z "
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 222 L 392 224.5 L 391 224.5 L 391.5 222 Z "
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 400.5 223 L 399.5 225 L 400.5 223 Z "
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 224 L 103.5 228 L 100.5 224 Z "
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 224 L 109 226.5 L 108 226.5 L 108.5 224 Z "
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 225 L 98.5 228 Q 95.5 226.5 98.5 225 Z "
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 226 L 124 226.5 Q 121.9 229.8 121.5 226 Z "
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 226 L 155.5 228 L 154.5 226 Z "
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 376.5 226 L 378.5 226 L 380 226.5 L 377.5 228 L 376.5 226 Z "
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 388.5 226 L 389 230 L 387 230.5 L 387.5 232 L 385 230.5 L 388 228.5 L 388.5 226 Z "
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 395.5 228 L 393 231.5 L 394 233.5 L 392.5 237 L 392 231.5 L 395.5 228 Z "
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 229 L 100.5 232 L 98.5 229 Z "
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111 229 Q 114 227.8 113 231.5 L 113.5 233 L 111 232.5 L 111 229 Z "
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 323.5 229 L 323 230.5 L 322.5 232 L 322 230.5 L 323.5 229 Z "
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 346.5 229 L 347 231.5 L 346 231.5 L 346.5 229 Z "
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 232 L 106.5 234 L 107.5 232 Z "
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 326.5 232 L 342 232.5 L 326.5 233 L 326.5 232 Z "
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 232 L 363 234.5 L 362 234.5 L 362.5 232 Z "
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 234 L 113 236 L 115 236.5 L 113.5 237 L 112.5 234 Z "
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 385.5 234 L 384.5 236 L 385.5 234 Z "
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 235 L 251.5 237 L 252.5 235 Z "
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 402.5 235 L 399.5 239 L 402.5 235 Z "
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 236 L 99.5 238 L 98.5 236 Z "
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 236 L 108 244.5 L 107 244.5 L 106 239.5 L 107.5 236 Z "
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 237 L 114.5 240 L 116.5 237 Z "
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 238 L 390 250.5 L 389 250.5 Q 390.8 244.2 388 242.5 L 388 240.5 L 389.5 238 Z "
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 417.5 238 L 418 240.5 L 417 240.5 L 417.5 238 Z "
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 385.5 239 L 386.5 241 L 385.5 239 Z "
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 240 L 83 245.5 L 82 245.5 L 82.5 240 Z "
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 240 L 113 242.5 L 111 241.5 L 111.5 240 Z "
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 240 L 158 241.5 L 155 243.5 L 157.5 240 Z "
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 240 L 174.5 242 L 173.5 240 Z "
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 241 L 235.5 243 L 234.5 241 Z "
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 241 L 362 252.5 L 361 252.5 L 361.5 241 Z "
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 242 L 92.5 245 L 90.5 242 Z "
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 242 L 134.5 244 L 135.5 242 Z "
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 242 L 256.5 246 L 253.5 242 Z "
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 244 L 325 246.5 L 324 246.5 L 324.5 244 Z "
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 244 L 330.5 246 L 331.5 244 Z "
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 246 L 152 249.5 L 151 249.5 L 151.5 246 Z "
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 246 L 155 250.5 L 154 250.5 L 154.5 246 Z "
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251 246 Q 254.3 244.7 253 249.5 L 254 249.5 L 254.5 248 L 255 249.5 L 253.5 252 L 251 246 Z "
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 269.5 246 L 270 248.5 L 269 248.5 L 269.5 246 Z "
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 248 L 97 250.5 L 95 249.5 L 96.5 248 Z "
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257.5 248 L 258 249.5 L 256 250.5 L 257.5 248 Z "
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 403.5 248 L 405 251.5 L 403 252.5 L 402 249.5 L 403.5 248 Z "
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 417.5 248 L 418 250.5 L 417 250.5 L 417.5 248 Z "
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 249 L 247.5 251 Q 244.7 251.7 246.5 249 Z "
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 250 L 238 251.5 L 238.5 250 L 239.5 252 L 237.5 253 L 235.5 250 Z "
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 250 L 260 253 L 264 254.5 L 262.5 255 L 258 252.5 L 259.5 250 Z "
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 250 L 263 252 L 261 251.5 L 262.5 250 Z "
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 250 L 349 253.5 L 348 253.5 L 348.5 250 Z "
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 250 L 366.5 254 L 369.5 250 Z "
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 251 L 325 252.5 L 324.5 254 L 324 252.5 L 325.5 251 Z "
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 251 L 342 251.5 L 338.5 253 L 338.5 252 L 340.5 251 Z "
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 252 L 157.5 255 L 155.5 252 Z "
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 252 L 245 253.5 L 244.5 255 L 244 253.5 L 245.5 252 Z "
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 266.5 253 L 267 255 L 265 254.5 L 266.5 253 Z "
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 398.5 253 Q 401.8 251.9 401 254.5 L 399.5 257 L 398.5 253 Z "
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 255 L 277 255.5 L 274.5 256 L 274.5 255 Z "
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 256 L 103.5 258 L 104.5 256 Z "
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 256 L 155.5 258 L 154.5 256 Z "
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 256 L 226 257.5 L 223.5 259 L 223.5 258 Q 226 258.7 225.5 256 Z "
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 395.5 256 L 397 259.5 L 395 258.5 L 395.5 256 Z "
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 407.5 256 L 407 257.5 L 404.5 263 L 404 261.5 L 407.5 256 Z "
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 415.5 256 L 415 257.5 Q 415.8 259.8 413.5 259 L 412 259.5 L 415.5 256 Z "
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 257 L 87.5 260 L 85 259 L 85.5 257 Z "
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 257 L 94.5 259 Q 91.7 259.7 93.5 257 Z "
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 257 L 348.5 259 L 347.5 257 Z "
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 328.5 258 L 330 258.5 L 327.5 260 L 328.5 258 Z "
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 259 L 233.5 261 L 235 260.5 L 232.5 264 L 233 262.5 L 232.5 259 Z "
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 268.5 259 L 271 260.5 L 269.5 260 L 268.5 259 Z "
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 261 Q 88 263 83.5 265 L 84.5 261 Z "
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 262 L 226 263.5 L 224.5 264 L 223.5 262 Z "
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 262 Q 230.1 261.2 229 264.5 L 227 265.5 L 228 263.5 L 227.5 262 Z "
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 262 L 392 267.5 L 391 267.5 L 391.5 262 Z "
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110 263 L 112 263.5 L 110.5 267 L 110 263 Z "
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 276.5 263 L 278 263.5 L 275.5 265 L 276.5 263 Z "
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 413.5 263 L 411.5 266 L 413.5 263 Z "
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 264 L 140 266.5 L 139 266.5 L 139.5 264 Z "
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 264 L 241.5 266 L 242.5 264 Z "
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 265 L 91 266.5 L 89.5 266 L 88.5 265 Z "
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 265 L 250.5 267 L 251.5 265 Z "
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 265 L 265.5 267 L 264.5 265 Z "
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 266 L 138 269.5 L 137 269.5 L 137.5 266 Z "
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 266 L 226.5 268 L 225.5 266 Z "
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 266 L 230.5 268 Q 227.7 268.7 229.5 266 Z "
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 266 L 254.5 268 L 253 267.5 L 252.5 269 L 252 267.5 L 253.5 266 Z "
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 266 L 273.5 268 L 271 267.5 L 272.5 266 Z "
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 267 L 85.5 267 L 91 272.5 L 89.5 272 Q 87.3 272.8 88 270.5 L 85.5 268 Q 83.7 270.5 83.5 267 Z "
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 267 L 263.5 269 L 262.5 267 Z "
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 268 L 109 270.5 L 108 270.5 L 108.5 268 Z "
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 268 L 220 269.5 L 219.5 271 L 219 269.5 L 220.5 268 Z "
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 269 L 230.5 271 Q 227.7 271.7 229.5 269 Z "
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 273.5 269 L 277 273.5 L 276 273.5 L 275.5 272 Q 274.3 274.3 273 271.5 L 273.5 269 Z "
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 270 L 99.5 272 L 100.5 270 Z "
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 270 L 114 273.5 L 113 273.5 L 113.5 270 Z "
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 271 L 224.5 273 L 223.5 271 Z "
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 271 L 278.5 273 L 279.5 271 Z "
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 399.5 271 L 400.5 273 L 399.5 271 Z "
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 272 L 100.5 274 L 101.5 272 Z "
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 272 L 227.5 274 L 228.5 272 Z "
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 273 L 87.5 276 L 85.5 273 Z "
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 255.5 273 L 256 275 L 253 274.5 L 255.5 273 Z "
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 392.5 273 L 393 275.5 L 391.5 278 L 391 276.5 L 392.5 273 Z "
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 398.5 273 L 399.5 275 L 398.5 273 Z "
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 274 Q 123.3 275.3 121 276.5 L 120.5 278 L 120.5 274 Z "
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 274 L 234 276.5 L 233 276.5 L 233.5 274 Z "
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247 274 L 250.5 275 L 252 274.5 L 251 276.5 L 251 278.5 L 252 280.5 L 250.5 280 L 248.5 281 L 250 278.5 L 248.5 275 L 247.5 277 L 247 274 Z "
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 275 L 109 279.5 L 108 279.5 L 107.5 275 Z "
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224 275 L 227 276.5 L 224 277 L 224 275 Z "
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 275 L 382 279.5 L 380 280.5 L 381.5 275 Z "
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 397.5 275 L 398.5 277 L 397.5 275 Z "
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 276 L 84 277.5 L 83.5 279 L 83 277.5 L 84.5 276 Z "
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 276 L 236 278.5 L 235 278.5 L 235.5 276 Z "
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 276 Q 292.5 277.5 289.5 279 L 289.5 276 Z "
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 276 L 388 279 L 386 278.5 L 387.5 276 Z "
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 416.5 276 L 417 279.5 L 416 279.5 L 415 277.5 L 416.5 276 Z "
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 277 L 102.5 279 L 103.5 277 Z "
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 277 L 254.5 279 L 253.5 277 Z "
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 263.5 277 L 261.5 280 L 263.5 277 Z "
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 278 Q 115.5 279.5 112.5 281 L 112.5 278 Z "
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 278 L 228 278.5 L 224.5 281 L 224.5 279 Q 221.5 279.5 222.5 278 Z "
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 279 L 124 285 L 122 285 L 122.5 279 Z "
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 377.5 280 L 378 282.5 L 376 283.5 L 377.5 280 Z "
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 395.5 280 L 396.5 282 L 395.5 280 Z "
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 281 L 93 281.5 L 92.5 284 L 90.5 281 Z "
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 276.5 281 L 276 282.5 L 273.5 287 L 272.5 285 L 274 284.5 L 273.5 283 L 276.5 281 Z "
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 282 L 89.5 285 L 87.5 282 Z "
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 282 Q 254.8 280.9 254 283.5 L 252.5 283 L 250.5 284 L 251.5 282 Z "
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 282 L 282.5 284 L 283.5 282 Z "
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 282 L 389 283.5 L 389 293.5 L 388 293.5 L 388 283.5 L 387.5 282 Z "
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 392 282 L 395 282.5 L 392.5 284 L 392 282 Z "
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 412.5 282 L 411.5 284 L 412.5 282 Z "
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 283 L 221 286.5 L 219 285.5 L 219.5 283 Z "
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 284 L 225.5 286 L 226.5 284 Z "
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 284 L 229.5 286 L 230.5 284 Z "
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 374.5 284 L 375 288.5 L 373.5 291 L 372 287.5 L 373 287.5 L 373.5 289 L 374.5 284 Z "
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 285 L 112 293 L 109 292.5 L 111 292 L 111.5 285 Z "
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 285 L 383.5 287 L 382.5 285 Z "
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 413.5 285 L 411.5 288 L 413.5 285 Z "
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 286 L 110 287.5 L 109.5 290 L 108.5 287 Q 106.7 289.5 106.5 286 Z "
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 378.5 286 L 377.5 288 L 378.5 286 Z "
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 393.5 286 L 394 287.5 L 392 288.5 L 393.5 286 Z "
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 287 L 122.5 289 L 121.5 287 Z "
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 287 L 229 290.5 L 226.5 289 L 225 288.5 L 226.5 287 Z "
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229 287 L 231 287.5 L 229 288.5 L 229 287 Z "
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 288 L 115.5 290 L 116.5 288 Z "
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 288 L 127 291.5 L 126 291.5 L 125.5 288 Z "
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 288 L 264.5 290 L 265.5 288 Z "
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 384.5 288 L 386 291.5 L 384 290.5 L 384.5 288 Z "
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 273.5 289 L 273 290.5 L 271.5 293 L 271.5 290 L 273.5 289 Z "
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 379.5 289 L 378.5 291 L 379.5 289 Z "
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 290 L 121.5 292 L 120.5 290 Z "
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 275.5 290 L 276.5 292 Q 273.7 292.7 275.5 290 Z "
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 390.5 290 L 393 291.5 L 391.5 291 L 390.5 290 Z "
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 291 L 89.5 294 L 87.5 291 Z "
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 291 L 223.5 293 L 224.5 291 Z "
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 291 L 232.5 293 L 235 294.5 L 233.5 294 L 231 292.5 L 232.5 291 Z "
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 291 L 261.5 293 L 262.5 291 Z "
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 375.5 292 L 374.5 294 L 375.5 292 Z "
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 293 L 125.5 295 L 124.5 293 Z "
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 293 Q 286.5 294.5 283.5 296 L 283.5 293 Z "
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 385.5 293 L 386.5 295 Q 383.7 295.7 385.5 293 Z "
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 390.5 293 L 391.5 295 L 390.5 293 Z "
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 394.5 293 L 395.5 295 L 394.5 293 Z "
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 294 L 107.5 296 L 106 295.5 L 108.5 294 Z "
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 294 L 115 295.5 L 113.5 298 L 111 297.5 L 114.5 294 Z "
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 295 L 109.5 297 L 110.5 295 Z "
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 295 L 124.5 297 L 123.5 295 Z "
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 295 L 255 295.5 L 249.5 296 L 249.5 295 Z "
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 296 L 390.5 298 L 389.5 296 Z "
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 297 L 227 299.5 L 225 298.5 L 225.5 297 Z "
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 297 L 239 299 L 237 299.5 L 237.5 301 Q 236 298.5 234.5 302 L 233 301.5 L 236 299.5 L 235.5 298 Q 237 300.5 238.5 297 Z "
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 297 L 265 297.5 L 264 298.5 L 266.5 302 Q 265 298.5 263.5 301 L 261 299.5 L 262.5 300 L 264 299.5 L 262.5 297 Z "
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 377.5 297 L 376.5 299 L 377.5 297 Z "
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 297 L 388.5 299 L 387.5 297 Z "
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 298 L 90.5 300 L 89.5 298 Z "
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 299 L 243 300 L 243.5 302 L 244.5 300 L 246 302.5 L 243.5 303 L 240.5 299 Z "
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 378.5 299 L 377.5 301 L 378.5 299 Z "
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 299 L 390.5 301 L 391.5 299 Z "
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 300 L 90.5 303 L 88 302.5 L 88.5 300 Z "
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 300 L 122.5 302 L 121.5 300 Z "
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 383.5 300 L 384 301.5 L 382.5 304 L 382 302.5 L 383.5 300 Z "
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 411.5 300 L 409.5 303 L 411.5 300 Z "
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 301 L 117 303 L 115 302.5 L 116.5 301 Z "
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 301 L 260 302.5 L 259.5 305 L 258 302.5 L 260.5 301 Z "
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 302 L 240 303.5 L 238 304.5 L 237.5 303 L 235 304.5 L 237.5 302 Z "
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 303 L 255 307.5 L 254 307.5 L 253.5 303 Z "
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 303 Q 263.8 302.3 263 304.5 L 261.5 303 Z "
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 304 L 118 306.5 L 117 306.5 L 117.5 304 Z "
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241 304 L 243 304.5 L 241 305.5 L 241 304 Z "
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 304 L 246.5 306 L 247.5 304 Z "
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 256.5 304 L 258 306.5 L 257 306.5 L 256.5 304 Z "
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 304 L 380 305.5 L 379.5 307 L 379 305.5 L 380.5 304 Z "
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 304 L 389.5 307 L 387.5 304 Z "
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 305 L 114 305.5 L 112.5 307 L 110 306.5 L 111.5 305 Z "
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 305 L 121 307.5 L 119 306.5 L 119.5 305 Z "
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251 306 Q 254.3 304.7 253 309.5 L 251 308.5 L 251 306 Z "
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 269.5 306 L 270 308.5 L 269 308.5 L 269.5 306 Z "
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 306 L 361 307.5 L 360.5 309 L 360 307.5 L 361.5 306 Z "
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 306 L 384 308.5 L 382 307.5 L 382.5 306 Z "
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 307 L 93.5 309 L 92 308.5 L 94.5 307 Z "
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 405.5 307 L 408 308.5 L 406.5 309 L 405.5 307 Z "
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 308 L 259.5 310 L 260.5 308 Z "
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 403.5 308 L 404.5 310 L 403.5 308 Z "
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 309 L 108 311.5 L 106.5 312 Q 105.2 309.7 100.5 311 L 99.5 309 Z "
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 309 L 242.5 311 L 241.5 309 Z "
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 309 L 382.5 311 L 381.5 309 Z "
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 399.5 309 L 400 311 L 398 310.5 L 399.5 309 Z "
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 384.5 310 L 386 312.5 L 385 312.5 L 384.5 310 Z "
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 394.5 310 L 397 310.5 L 392.5 312 L 392.5 311 L 394.5 310 Z "
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 388.5 311 Q 390.8 310.3 390 312.5 L 388.5 311 Z "
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 312 L 119.5 314 L 120.5 312 Z "
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 314 Q 385.5 315.5 382.5 317 L 382.5 314 Z "
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 315 L 119 315.5 L 118.5 317 L 120 317.5 L 118.5 318 L 116.5 315 Z "
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 378.5 315 L 380 315.5 L 378 316.5 L 378.5 318 Q 375.5 316.5 378.5 315 Z "
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 404.5 315 L 403.5 317 L 404.5 315 Z "
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 316 L 132.5 318 L 131.5 316 Z "
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 318 L 127 321.5 L 126 321.5 L 126.5 318 Z "
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 318 L 252.5 320 L 251.5 318 Z "
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 319 L 109 319.5 L 104.5 320 L 104.5 319 Z "
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 319 L 395 319.5 L 391.5 320 L 391.5 319 Z "
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 320 L 143 322 L 141 321.5 L 142.5 320 Z "
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 320 L 161.5 322 L 160.5 320 Z "
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 366.5 320 L 369 320.5 L 368.5 323 L 366 322.5 L 366.5 320 Z "
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 322 L 394 322.5 L 391.5 323 L 391.5 322 Z "
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 323 L 148 332.5 L 147 332.5 L 147.5 323 Z "
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358 323 L 360 323.5 L 358 324.5 L 358 323 Z "
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 324 Q 143.1 323.2 142 326.5 L 141 326.5 L 140.5 324 Z "
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 339.5 324 L 338.5 326 L 339.5 324 Z "
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 354.5 324 L 355 327.5 L 354 327.5 L 354.5 324 Z "
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 324 L 362 325.5 L 360 326.5 L 361.5 324 Z "
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 325 L 163.5 328 L 161.5 325 Z "
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 325 L 165.5 327 L 164.5 325 Z "
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335.5 325 L 334.5 327 L 335.5 325 Z "
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 325 L 353 327.5 L 352 327.5 L 352.5 325 Z "
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 326 Q 100.8 325.3 100 327.5 L 98.5 326 Z "
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 326 L 140 328.5 L 138 327.5 L 138.5 326 Z "
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 367.5 326 L 368 328.5 L 367 328.5 L 367.5 326 Z "
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 327 L 371.5 329 L 370.5 327 Z "
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 328 L 252.5 330 L 251.5 328 Z "
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 395.5 328 L 398 329.5 L 396.5 329 L 395.5 328 Z "
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 329 L 113 329.5 L 109.5 330 L 109.5 329 Z "
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 329 L 134 331.5 L 131.5 333 L 130.5 330 L 129.5 329 Z "
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 388.5 329 L 391 329.5 L 388.5 330 L 388.5 329 Z "
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 330 L 363 337 Q 359.3 338.4 361 332.5 L 362.5 330 Z "
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 379.5 330 L 382 330.5 L 379.5 331 L 379.5 330 Z "
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 331 L 329.5 336 L 333.5 331 Z "
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 332 L 129 332.5 Q 126.9 335.8 126.5 332 Z "
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 332 Q 252.8 331.3 252 333.5 L 252.5 335 Q 250.3 335.8 251 333.5 L 249.5 334 L 247.5 335 L 248.5 333 L 250.5 332 Z "
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 253.5 332 L 256 333.5 L 254.5 333 L 253.5 332 Z "
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 333 L 145 335.5 L 144 335.5 L 144.5 333 Z "
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 393 333 L 395 333.5 L 393 334.5 L 393 333 Z "
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 335 L 115 335.5 L 112.5 337 L 113.5 335 Z "
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 335 L 172.5 338 L 170.5 335 Z "
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 336 Q 105.8 335.3 105 337.5 L 103.5 336 Z "
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 336 L 149.5 338 L 148.5 336 Z "
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 336 Q 155.8 335.3 155 337.5 L 153.5 336 Z "
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 337 L 142 339.5 L 141 339.5 L 141.5 337 Z "
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 337 L 354 340.5 L 353 340.5 L 352 338.5 L 353.5 337 Z "
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 338 L 107.5 340 L 108.5 338 Z "
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 338 L 136.5 340 L 135.5 338 Z "
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 388.5 339 L 391 340.5 L 389.5 340 L 388.5 339 Z "
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 340 L 132 340.5 L 129.5 342 L 130.5 340 Z "
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 340 L 352 342.5 L 351 342.5 L 351.5 340 Z "
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 340 L 357 344.5 L 356 344.5 L 356.5 340 Z "
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 340 L 370.5 342 Q 367.7 342.7 369.5 340 Z "
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 341 L 135 343.5 Q 135.9 346.5 131.5 345 L 131.5 344 L 134 343.5 Q 131.8 342.3 134.5 341 Z "
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 341 L 179 344.5 L 178 344.5 L 178.5 341 Z "
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 341 L 315 343.5 L 314 343.5 L 314.5 341 Z "
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 341 L 361.5 343 L 360.5 341 Z "
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 341 L 366.5 344 L 369 344.5 L 366.5 345 L 365 343.5 L 365.5 341 Z "
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 342 L 149 348.5 L 148 348.5 L 148.5 342 Z "
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 342 L 164.5 344 L 163.5 342 Z "
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 336.5 342 L 337 349.5 L 336 349.5 L 335 344.5 L 336.5 342 Z "
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 343 L 124 343.5 L 121.5 344 L 121.5 343 Z "
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 343 L 358.5 345 L 359.5 343 Z "
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 343.5 344 L 343 345.5 L 342.5 347 L 342 345.5 L 343.5 344 Z "
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389 344 L 391 344.5 L 389 345.5 L 389 344 Z "
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 345 L 113.5 347 L 114.5 345 Z "
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 345 L 387.5 347 L 386.5 345 Z "
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 346 L 142.5 348 L 141.5 346 Z "
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 346 L 158 352.5 L 157 352.5 L 157.5 346 Z "
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 347 Q 140.3 348.3 138 349.5 L 137.5 351 L 129.5 351 L 129.5 350 Q 135.3 350.8 138 348.5 L 137.5 347 Z "
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 347 L 166 353.5 L 165 353.5 L 165.5 347 Z "
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 347 L 350 349.5 L 349 349.5 L 349.5 347 Z "
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 347 L 358 347.5 Q 355.9 350.8 355.5 347 Z "
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 348 L 129 348.5 L 122.5 349 L 122.5 348 Z "
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 348 L 156 355.5 L 154 356.5 L 155.5 348 Z "
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 348 L 332 350.5 L 330 351 L 330.5 348 Z "
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 348 L 378 348.5 L 372.5 349 L 372.5 348 Z "
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 349 L 370 350.5 L 364.5 351 L 362.5 349 Z "
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 383 349 L 385 349.5 L 383 350.5 L 383 349 Z "
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 350 L 123 350.5 L 119.5 352 L 120.5 350 Z "
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 350 Q 148.3 353.1 150 351.5 L 149.5 356 L 146 352.5 L 146.5 350 Z "
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 377.5 350 L 381 351.5 L 379.5 351 Q 376.5 351.5 377.5 350 Z "
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 351 Q 115.8 350.3 115 352.5 L 113.5 351 Z "
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 351 Q 143.3 352.3 141 353.5 L 140.5 355 L 138 353.5 L 141 352.5 L 140.5 351 Z "
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 351 L 359.5 353 L 362 353.5 L 358.5 355 L 358.5 353 L 356.5 354 L 357.5 352 L 359.5 351 Z "
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 351 L 384.5 354 L 384 352 L 386.5 351 Z "
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 353 L 117.5 355 L 118.5 353 Z "
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 353 L 144.5 355 L 143.5 353 Z "
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 353 L 349.5 357 L 348.5 355 L 349.5 356 L 352.5 353 Z "
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 353 L 382.5 355 L 381.5 353 Z "
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 378.5 354 L 381 355.5 L 379.5 355 L 378.5 354 Z "
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 355 L 130 355.5 L 126.5 356 L 126.5 355 Z "
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 355 L 135 355.5 L 131.5 356 L 131.5 355 Z "
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 355 L 163 357.5 L 162 357.5 L 162.5 355 Z "
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 355 L 346 357.5 L 344 356.5 L 344.5 355 Z "
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 355 L 367 355.5 L 364.5 356 L 364.5 355 Z "
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 371.5 355 L 374 355.5 L 371.5 356 L 371.5 355 Z "
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 356 L 142.5 358 L 141.5 356 Z "
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 356 L 357.5 358 L 358.5 356 Z "
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 357 L 140.5 359 L 139.5 357 Z "
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 357 L 363 357.5 L 360.5 359 L 361.5 357 Z "
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 358 L 324 359.5 L 323.5 361 L 323 359.5 L 324.5 358 Z "
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 358 L 355 359.5 L 353 360.5 L 352.5 359 L 351 359.5 L 352.5 358 Z "
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 359 L 144.5 361 L 145.5 359 Z "
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 359 L 152.5 364 L 148.5 359 Z "
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 359 Q 178.1 358.2 177 361.5 L 176 361.5 L 175.5 359 Z "
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 360 L 134 360.5 L 131.5 362 L 132.5 360 Z "
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 367 360 Q 370 359 369 362 Q 366 363 367 360 Z "
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 362 L 175 364.5 L 174 364.5 L 174.5 362 Z "
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 363 L 159.5 365 L 158.5 363 Z "
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 363 L 182 366.5 L 181 366.5 L 180.5 363 Z "
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318 363 L 320 363.5 L 318 364.5 L 318 363 Z "
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 339.5 363 L 342 363.5 L 339 365.5 L 339.5 363 Z "
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 365 L 168 366.5 L 166 367.5 L 167.5 365 Z "
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 366 L 152 366.5 L 146.5 367 L 146.5 366 Z "
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 257.5 366 L 258 367.5 L 256 368.5 L 257.5 366 Z "
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 332.5 366 L 334 368.5 L 332 367.5 L 332.5 366 Z "
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 366 L 354 366.5 L 349.5 367 L 349.5 366 Z "
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 367 L 268 367.5 L 265.5 368 L 265.5 367 Z "
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 346.5 367 L 345.5 369 L 346.5 367 Z "
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 368 L 175 370.5 L 174 370.5 L 174.5 368 Z "
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 368 L 187 371.5 L 186 371.5 L 185.5 368 Z "
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 368 L 247.5 373 L 243.5 368 Z "
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335.5 368 L 338 368.5 L 333 372.5 Q 337.2 370.2 335.5 368 Z "
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 369 L 146 369.5 L 143.5 370 L 143.5 369 Z "
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 369 L 163.5 375 L 158.5 369 Z "
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 369 L 167.5 369 L 169 369.5 L 166 371.5 L 166.5 373 L 165 371.5 L 165.5 369 Z "
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 370 L 134.5 372 L 133.5 370 Z "
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 371 L 354 371.5 L 351.5 372 L 351.5 371 Z "
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 371 L 369.5 373 Q 366.7 373.7 368.5 371 Z "
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 373 L 187 376.5 L 186 376.5 L 186.5 373 Z "
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 291.5 373 L 290.5 375 L 291.5 373 Z "
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 373 L 317 377.5 L 316 377.5 L 316.5 373 Z "
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 337.5 373 L 336.5 377 L 334 376.5 L 337.5 373 Z "
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 374 L 150 374.5 L 146.5 375 L 146.5 374 Z "
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 374 L 172.5 378 L 171.5 376 L 172.5 377 L 175.5 374 Z "
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 374 L 209.5 376 L 208.5 374 Z "
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302 374 Q 304.7 372.9 304 375.5 L 302 376.5 L 302 374 Z "
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 374 L 326.5 377 Q 324.3 377.8 325 375.5 L 324.5 374 Z "
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 374 L 355 374.5 L 352.5 375 L 352.5 374 Z "
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 375 L 137 376.5 L 135.5 377 L 134.5 375 Z "
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 375 L 156 375.5 L 152.5 376 L 152.5 375 Z "
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 375 L 195 378.5 L 194 378.5 L 194.5 375 Z "
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 375 L 197 380.5 L 196 380.5 L 196.5 375 Z "
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 375 L 348 375.5 L 344.5 376 L 344.5 375 Z "
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 376 L 309 380.5 L 308 380.5 L 308.5 376 Z "
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 367.5 376 L 371 378.5 L 369.5 378 L 367.5 376 Z "
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 377 L 214 382.5 L 213 382.5 L 212 378.5 L 213.5 377 Z "
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 291.5 378 L 292 383.5 L 291 383.5 L 291.5 378 Z "
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 378 L 294 380.5 L 293 380.5 L 293.5 378 Z "
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 379 L 167 379.5 L 163.5 380 L 163.5 379 Z "
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 379 Q 172.5 380.5 169.5 382 L 169.5 379 Z "
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 379 L 176.5 381 L 175.5 379 Z "
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 334.5 379 L 338 379.5 L 334.5 380 L 334.5 379 Z "
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 379 L 358.5 381 L 359.5 379 Z "
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 380 L 203 382 L 201 381.5 L 202.5 380 Z "
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 380 L 207 386.5 L 206 386.5 L 206.5 380 Z "
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 380 L 209 382.5 L 208 382.5 L 208.5 380 Z "
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 380 L 252 380.5 L 248.5 381 L 248.5 380 Z "
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 380 L 289 385.5 L 288 385.5 L 288.5 380 Z "
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 380 L 298 381.5 L 297.5 383 L 297 381.5 L 298.5 380 Z "
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 315.5 380 L 316.5 382 L 315.5 380 Z "
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 380 L 328.5 382 L 329.5 380 Z "
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 381 L 162 382.5 L 157.5 383 L 156.5 381 Z "
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 343.5 381 L 344 383 L 340 382.5 L 343.5 381 Z "
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 382 L 183 384.5 L 182 384.5 L 181.5 382 Z "
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 382 L 184.5 384 L 185.5 382 Z "
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 382 L 212 384.5 L 211 384.5 L 211.5 382 Z "
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 383 L 175.5 385 L 174.5 383 Z "
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 384 L 173 384.5 L 170.5 385 L 170.5 384 Z "
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 384 Q 188.7 388.2 191 386.5 L 188 388.5 L 189 387.5 L 186.5 384 Z "
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 384 L 222.5 386 L 220 385.5 L 221.5 384 Z "
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 384 L 279.5 386 L 277 385.5 L 278.5 384 Z "
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 384 L 325 386.5 L 324 386.5 L 324.5 384 Z "
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 328.5 384 L 332 384.5 L 328.5 385 L 328.5 384 Z "
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 301.5 387 L 302.5 389 L 301.5 387 Z "
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 387 L 326 388.5 L 321.5 389 L 320.5 387 Z "
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 387 L 333 387.5 L 329.5 388 L 329.5 387 Z "
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 388 L 179 388.5 L 174.5 389 L 174.5 388 Z "
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 388 L 198.5 390 L 199.5 388 Z "
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 388 L 250 389.5 L 249.5 391 L 249 389.5 L 250.5 388 Z "
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 389 L 217.5 391 L 216.5 389 Z "
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 389 L 225.5 392 Q 222.5 390.5 225.5 389 Z "
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 389 L 275.5 391 Q 272.7 391.7 274.5 389 Z "
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300.5 389 L 299.5 391 L 300.5 389 Z "
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 390 L 349 392.5 L 348 392.5 L 347.5 390 Z "
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 285.5 391 L 284.5 393 L 285.5 391 Z "
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 392 L 151 394 L 149 393.5 L 150.5 392 Z "
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 392 L 184 392.5 L 180.5 393 L 180.5 392 Z "
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 392 L 213.5 394 L 212.5 392 Z "
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 392 L 216.5 394 L 215.5 392 Z "
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 392 L 313.5 394 L 312.5 392 Z "
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 392 L 321 392.5 L 316.5 393 L 316.5 392 Z "
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 394 L 191 395.5 L 190.5 397 L 190 395.5 L 191.5 394 Z "
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 394 Q 207.5 395.5 204.5 397 L 204.5 394 Z "
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 395 L 154.5 397 L 153.5 395 Z "
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 395 L 295.5 397 L 294.5 395 Z "
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 396 L 152.5 398 L 151.5 396 Z "
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 396 L 224.5 398 L 223.5 396 Z "
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 396 L 226.5 398 L 227.5 396 Z "
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 396 L 245 396.5 L 242.5 398 L 243.5 396 Z "
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 396 L 273.5 398 L 272.5 396 Z "
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 396 Q 284.5 397.5 281.5 399 L 279 398.5 L 281.5 396 Z "
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 396 L 347.5 398 L 348.5 396 Z "
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 397 L 310 398.5 L 304.5 399 L 303.5 397 Z "
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335.5 397 L 334.5 399 L 335.5 397 Z "
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 398 L 196 398.5 L 190.5 399 L 190.5 398 Z "
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 398 L 223 400 L 221 399.5 L 222.5 398 Z "
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 326.5 398 L 325.5 400 L 326.5 398 Z "
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 399 L 159.5 402 L 161.5 399 Z "
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 399 L 173 401 L 171 400.5 L 172.5 399 Z "
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 399 L 199 402 L 197 401.5 L 198.5 399 Z "
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 399 L 241 399.5 Q 238.9 402.8 238.5 399 Z "
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 400 L 204.5 402 L 206 401.5 L 204.5 404 L 204 402 L 202 401.5 L 203.5 400 Z "
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 401 L 194 401.5 L 191.5 402 L 191.5 401 Z "
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 401 L 280 403.5 L 279 403.5 L 279.5 401 Z "
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 401 L 296.5 404 L 294.5 401 Z "
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 306.5 401 L 309 401.5 L 306.5 402 L 306.5 401 Z "
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 402 L 207.5 405 Q 204.5 403.5 207.5 402 Z "
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 403 L 177.5 406 Q 176.3 403.8 175 406.5 L 174.5 408 L 174 406.5 L 177.5 403 Z "
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 403 L 203 404.5 L 201.5 404 L 200.5 403 Z "
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 403 L 253.5 405 L 252.5 403 Z "
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 403 L 290.5 405 L 289.5 403 Z "
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 258.5 404 L 259 408.5 L 258 408.5 L 258.5 404 Z "
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 405 L 208.5 407 L 209.5 405 Z "
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 405 L 242 407.5 L 241 407.5 L 241.5 405 Z "
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 406 L 229.5 407 L 231 406.5 L 228.5 408 L 227.5 406 Z "
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183 407 L 186 408.5 L 183 409 L 183 407 Z "
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 407 L 315.5 409 L 313 408.5 L 316.5 407 Z "
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 409 L 194 410.5 L 191.5 411 L 190.5 409 Z "
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 409 L 221.5 411 L 220.5 409 Z "
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 409 L 310 409.5 Q 309.3 411.8 305.5 411 L 305.5 410 L 308.5 409 Z "
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 410 L 241.5 413 L 239.5 410 Z "
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 413 L 278 415.5 L 277 415.5 L 277.5 413 Z "
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 416 Q 247.8 415.3 247 417.5 L 245.5 416 Z "
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251 417 L 253 417.5 L 251.5 420 L 251 417 Z "
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 418 L 212.5 420 L 211.5 418 Z "
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 425 L 251 427.5 L 249 426.5 L 249.5 425 Z "
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(152,152,152)",
    stroke: "rgb(152,152,152)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 428 L 258.5 430 L 259.5 428 Z "
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 68 L 252.5 68 L 255.5 71 L 261 72 L 263.5 78 L 266 79.5 L 265 84.5 L 267 89.5 L 260.5 100 L 257.5 100 L 251.5 105 L 248.5 105 L 237 97.5 L 233 88.5 L 235 83.5 L 234 80.5 L 235 78 L 238 76.5 L 239 72 L 244.5 71 L 247.5 68 Z M 249 73 L 249 80 L 251 81 L 251 74 L 249 73 Z M 240 78 L 240 80 L 245 83 L 246 83 L 240 78 Z M 247 78 L 246 81 L 248 82 L 247 78 Z M 260 78 L 258 79 L 255 83 L 260 80 L 260 78 Z M 254 79 L 253 81 L 255 80 L 254 79 Z M 240 83 L 238 86 L 244 85 L 240 83 Z M 250 83 L 247 84 Q 246 89 250 90 L 252 89 Q 255 90 253 85 L 250 83 Z M 259 83 L 256 85 L 261 86 L 263 85 L 259 83 Z M 244 86 L 242 88 L 245 88 L 244 86 Z M 256 86 L 256 88 L 259 88 L 256 86 Z M 242 89 L 241 90 Q 238 89 239 92 L 239 93 L 245 90 L 242 89 Z M 257 89 L 261 93 Q 263 94 262 92 Q 261 88 257 89 Z M 246 91 L 243 96 L 245 96 L 247 92 L 246 91 Z M 251 91 L 249 93 Q 247 99 251 98 L 251 91 Z M 254 91 L 255 95 Q 254 97 257 96 L 256 93 L 254 91 Z M 249 100 Q 248 103 251 102 Q 252 99 249 100 Z "
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 70 Q 223.8 76.8 232 80.5 Q 230.8 83.2 229.5 81 L 227.5 81 L 221 75.5 L 218.5 70 Z "
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 70 L 281 71.5 L 276.5 78 L 269.5 82 Q 266.5 80.5 269.5 79 L 280 72.5 L 281.5 70 Z "
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 71 L 287 74.5 L 283.5 79 Q 278.7 84.2 270.5 86 L 268 84.5 Q 282.1 81.1 289.5 71 Z "
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 72 Q 218.6 81.4 232 84.5 L 229.5 86 Q 216.5 82.2 211.5 72 Z "
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 78 L 207.5 84 L 224 91.5 L 218.5 92 Q 209.3 89.2 204 82.5 L 202.5 78 Z "
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 79 Q 219.9 86.1 231 89.5 Q 229.8 92.3 228.5 90 Q 216.5 87.5 212.5 79 Z "
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 79 L 281.5 86 L 270.5 91 L 269.5 89 Q 280.7 86.2 287.5 79 Z "
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 79 L 296 81.5 L 291.5 87 Q 286.5 92 276.5 92 L 276.5 91 Q 290.6 88.6 297.5 79 Z "
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 85 L 251 87 L 249 86.5 L 250.5 85 Z "
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 87 L 198.5 88 L 219 94.5 L 214.5 96 L 196.5 89 L 187.5 88 L 187.5 87 Z "
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 305.5 87 L 313 87.5 L 307.5 88 L 290.5 95 L 283.5 96 L 281 94.5 L 289.5 93 L 305.5 87 Z "
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 90 L 186 90.5 L 182.5 91 L 182.5 90 Z "
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 90 L 315 90.5 L 298.5 97 L 290.5 97 L 290.5 96 L 312.5 90 Z "
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 91 L 191.5 91 L 210 96.5 L 206.5 98 L 187.5 92 L 187.5 91 Z "
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 94 L 202 98 Q 203.4 102 196.5 100 Q 190.5 96 181.5 95 L 181.5 94 Z "
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 94 L 233 95.5 L 231.5 97 L 216.5 99 L 193.5 106 Q 173.6 113.6 159.5 127 L 163.5 122 L 182 109.5 L 167 108.5 L 170.5 107 L 182 107 Q 180.9 109.7 183.5 109 L 200.5 101 L 230.5 94 Z "
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 267 94 L 292.5 99 L 318 109 L 318.5 107 L 328.5 107 L 333 108.5 L 318 109.5 Q 331.2 116.3 341 126.5 L 336.5 123 Q 323.3 112.7 306.5 106 L 283.5 99 L 268.5 97 L 267 95.5 L 267 94 Z "
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 94 L 320 94.5 L 303.5 100 L 298 100 Q 296.7 96.7 301.5 98 L 314.5 94 Z "
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 98 L 157 99.5 L 149 113.5 L 153 110.5 L 160.5 101 L 158 104.5 L 148 119.5 L 152 116.5 L 160.5 105 L 160 106.5 Q 156.9 116.9 148.5 122 L 146.5 121 L 143 127.5 L 145.5 126 L 155 120 L 155.5 118 L 156 119.5 L 150.5 126 L 142.5 131 Q 141.3 128.8 140 131.5 L 138 136.5 L 141.5 134 L 152.5 127 L 147.5 133 L 140 138.5 L 141.5 139 L 147.5 135 L 143.5 140 L 136.5 144 L 136 142.5 L 140 139.5 L 138 139 L 137.5 137 L 132 149.5 L 134 148.5 Q 133.3 146.3 135.5 147 L 141.5 143 L 156.5 139 L 158.5 137 L 156.5 140 L 141 146.5 L 143.5 147 L 155.5 143 L 154.5 145 L 132 153 L 131.5 150 Q 125.8 160.3 123 173.5 L 124 173.5 L 128.5 167 L 134.5 164 L 151.5 161 L 156.5 158 L 153.5 162 L 135 167.5 L 140.5 168 L 152.5 165 L 150.5 168 L 138.5 175 L 131.5 175 L 123 177 L 122.5 174 L 116 196.5 L 116 200.5 L 117 200.5 Q 116.5 195.5 120.5 195 L 138.5 188 L 137.5 190 L 124 196.5 L 125.5 197 L 128.5 196 L 128.5 197 L 116 204 L 115.5 201 L 112 219.5 L 112 228.5 L 111 229.5 L 111 251 Q 106.9 252.7 108 248.5 L 107 245.5 L 108 244.5 L 108 227.5 L 109 226.5 L 111 207.5 L 118 179 Q 114.7 180.3 116 175.5 L 108 157.5 L 109 157.5 L 113.5 165 L 114 162.5 L 111 156.5 L 112 156.5 L 113.5 159 L 114 156.5 L 110 147.5 L 111 147.5 L 120 163.5 L 120.5 172 L 124 161.5 L 122 161.5 L 115 149.5 L 113 140.5 L 115.5 133 L 117 139.5 L 124 152.5 L 124.5 161 Q 133.5 134.5 149 114.5 L 148 111.5 Q 151.2 103.2 157.5 98 Z M 116 142 L 115 145 L 116 145 L 116 142 Z M 139 170 L 139 171 L 142 171 L 139 170 Z M 135 171 L 135 172 L 138 172 L 135 171 Z M 120 172 L 118 176 L 119 179 L 120 176 L 120 172 Z "
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 98 L 181.5 98 L 195 101.5 L 191.5 103 L 179.5 99 L 173.5 99 L 173.5 98 Z "
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318.5 98 L 327 98.5 L 307.5 103 L 305 101.5 L 318.5 98 Z "
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 99 L 226 102.5 Q 223 112.5 216.5 119 L 218 116.5 L 225.5 99 Z "
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 99 Q 278.5 103 279 110.5 L 284 118.5 L 281 116.5 Q 275 109.4 274.5 99 Z "
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 343.5 99 Q 350.5 103.5 352 113.5 L 352 115.5 L 358.5 125 L 359 122.5 L 351 103.5 L 352 103.5 L 358 112.5 L 360 118.5 L 360 124.5 L 359 126.5 Q 373 147.5 380.5 175 L 381 171.5 Q 378.5 170 380 164.5 L 389.5 147 L 390 149.5 L 385 160.5 L 387 159.5 L 388.5 156 L 389 157.5 L 385 166.5 L 387 165.5 L 392.5 155 L 393 156.5 L 383.5 179 L 382 178.5 L 387 196.5 L 391 218.5 L 392 236.5 L 393 237.5 L 393 249.5 L 390 251 L 389 226.5 L 388 225.5 L 388 218.5 L 384.5 200 L 383.5 204 L 371 196.5 L 373.5 196 L 375.5 197 L 374.5 195 L 363 189.5 L 364.5 190 Q 376.6 191.4 383 198.5 L 383.5 200 L 384 195.5 L 378 173.5 L 369.5 152 L 368.5 154 L 344 143.5 L 345.5 143 Q 350.9 146.6 359.5 147 L 359.5 146 Q 348.1 143.9 341 137.5 L 343.5 139 Q 358.3 140.7 367 148.5 L 368.5 152 L 369 149.5 L 365.5 143 L 363.5 144 L 351 134.5 L 353.5 136 L 364.5 143 L 365 140.5 L 358.5 129 L 357.5 131 L 345 120.5 L 344 118.5 L 350.5 124 L 357.5 129 L 358 127.5 L 353.5 121 L 351.5 122 Q 342.4 115.1 338 103.5 L 342 106.5 L 352.5 121 L 353 119.5 L 340 102.5 L 345 106.5 L 350.5 114 L 351 112.5 L 343.5 99 Z M 382 175 L 381 178 L 382 178 L 382 175 Z "
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 100 L 222 103.5 L 214.5 115 L 216 112.5 L 221.5 100 Z "
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 100 L 286 114.5 L 283 112.5 L 278 103.5 L 278.5 100 Z "
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215 101 Q 217.7 99.9 217 102.5 Q 214.5 111 208.5 116 L 210 113.5 L 215 101 Z "
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 284.5 101 L 289 111.5 L 293 116.5 L 288 112.5 L 283 102.5 L 284.5 101 Z "
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 102 L 149 103.5 L 140.5 125 L 140 119.5 Q 142.9 108.9 149.5 102 Z "
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 211.5 102 L 212 103.5 L 196.5 127 L 198 124.5 Q 201.2 111.2 209.5 103 L 211.5 102 Z "
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 102 L 294 106.5 L 295.5 109 L 296 107.5 L 294 104.5 L 295.5 104 L 299 107.5 L 304 120.5 L 308 126.5 L 305 124.5 L 296.5 109 L 296 110.5 L 305 127.5 L 301 124.5 L 288.5 102 Z "
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 103 L 185.5 103 L 189 104.5 L 180.5 105 L 179.5 104 L 170.5 104 L 170.5 103 Z "
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 315.5 103 L 331 103.5 L 311.5 105 L 311.5 104 L 315.5 103 Z "
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 104 L 206 104.5 L 192.5 127 L 194 124.5 L 201 107.5 L 204.5 104 Z "
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 106 Q 200.8 105.3 200 107.5 L 189 126.5 L 185.5 130 L 188 126.5 L 194 111.5 L 198.5 106 Z "
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300.5 106 L 304 108.5 L 311 124.5 L 315 129.5 L 312 127.5 L 300.5 106 Z "
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 108 L 193 110.5 L 186 124.5 L 178.5 132 L 182 127.5 L 190 110.5 L 192.5 108 Z "
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 108 L 310 110.5 L 316 124.5 L 322 131.5 L 314 124.5 L 307 110.5 L 307.5 108 Z "
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 109 L 140 110.5 L 137 118.5 L 136.5 132 Q 133.1 129.4 134 122.5 Q 135.4 113.9 140.5 109 Z "
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 110 L 188 112.5 Q 182.8 124.3 173.5 132 L 178 126.5 Q 181 116.5 187.5 110 Z "
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237 110 Q 240.8 109 242 111.5 L 240.5 115 L 237 115 L 237 110 Z "
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 259.5 110 Q 263.9 108.5 263 111.5 L 263 113.5 Q 263.9 116.5 259.5 115 L 258 111.5 L 259.5 110 Z "
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 110 Q 319.4 117.1 323 127.5 L 327 131.5 L 319 124.5 L 312 112.5 L 312.5 110 Z "
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 110 Q 366.8 115.8 366 128.5 L 364.5 132 L 363 117.5 L 360.5 110 Z "
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 111 L 175 111.5 L 173.5 113 Q 166.1 112.1 162.5 115 L 163.5 113 L 169.5 111 Z "
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 111 L 330.5 111 L 340 115.5 L 338.5 115 L 332.5 113 L 326.5 113 L 325.5 111 Z "
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 113 L 182 114.5 L 170.5 130 L 167.5 132 L 173 125.5 L 181.5 113 Z "
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318.5 113 L 327 125.5 L 333 131.5 L 331.5 131 L 325 125.5 L 319 116.5 L 318.5 113 Z "
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 116 L 130 117.5 Q 129.6 128.9 134 135.5 L 132 136 L 129 129.5 L 128 122.5 L 130.5 116 Z "
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 116 L 169 116.5 Q 161.5 118.5 157.5 124 L 163.5 117 L 165.5 116 Z "
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 116 L 334.5 116 L 341 120.5 L 343 123.5 L 338.5 120 L 331.5 117 L 331.5 116 Z "
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 117 L 173 120.5 L 164.5 130 L 160.5 132 L 161.5 130 L 165 127.5 L 172.5 119 L 175.5 117 Z "
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 117 L 334 125.5 Q 333.3 127.8 335.5 127 L 339.5 132 Q 331.3 128.7 327 121.5 L 324.5 117 Z "
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 117 Q 372.9 120.1 372 126.5 L 367.5 136 L 367 133.5 Q 370.9 127.4 370.5 117 Z "
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 120 L 125 126.5 L 130 139.5 L 130 144.5 L 129 144.5 L 124 129.5 L 124.5 120 Z "
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 376.5 123 L 377 125.5 L 372 142.5 L 370.5 144 L 370 140.5 L 376.5 123 Z "
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 126 L 121 130.5 L 127 142.5 L 128 148.5 L 126.5 151 L 120 132.5 L 120.5 126 Z "
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 126 L 256 131.5 L 257 135 Q 253.7 132.9 245.5 134 L 243 135 L 249.5 126 Z "
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 127 L 361 135 L 362 138.5 L 359.5 137 Q 351 133.3 347.5 127 Z "
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 379.5 128 L 380 133.5 L 373.5 152 L 373 143.5 L 379.5 128 Z "
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 384.5 133 Q 387.8 136.2 387 143.5 L 384 152.5 L 377.5 162 Q 374.7 159.3 376 152.5 L 384 137.5 L 384.5 133 Z M 385 143 L 382 148 L 383 149 L 385 146 L 385 143 Z "
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 134 L 236 134.5 L 206.5 142 L 191 150 L 192.5 147 Q 207.8 137.8 228.5 134 Z "
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 134 Q 292.4 136.4 310 148 Q 311.1 150.7 308.5 150 L 302.5 146 L 287.5 140 L 266.5 136 L 264.5 134 Z "
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 141 Q 171.3 140.3 172 142.5 L 173 145.5 L 170.5 149 Q 166.8 149.8 166 147.5 L 165 144.5 L 167.5 141 Z "
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 141 Q 334.5 140.5 335 143.5 Q 335.8 147.3 333.5 148 L 330.5 149 L 328 148 L 328 142.5 L 329.5 142 L 330.5 141 Z "
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 149 L 152 149.5 Q 146.3 153.8 137.5 155 L 129.5 160 L 130 158.5 L 132.5 155 L 150.5 149 Z "
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 149 L 366.5 154 L 371 158.5 L 370.5 160 L 362.5 155 L 350.5 151 L 349.5 149 Z "
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 150 Q 185.5 149.5 186 152.5 Q 186.8 156.3 184.5 157 L 182.5 158 L 179 155.5 Q 178.3 150.8 181.5 150 Z "
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 150 Q 320.5 149.5 321 152.5 Q 321.8 156.3 319.5 157 L 317.5 158 L 314 155.5 Q 313.3 150.8 316.5 150 Z "
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 154 L 254 154.5 L 251 156.5 L 251 166.5 L 253 177.5 L 248.5 178 L 235.5 163 L 235 167.5 Q 237.7 169.2 236 175.5 L 238.5 178 L 240 178.5 L 230.5 180 L 231.5 178 L 233 177.5 L 233 167.5 Q 230.2 165.8 232 159.5 L 229.5 157 L 228 156.5 L 235.5 156 L 248.5 172 L 249 168.5 L 248 167.5 L 248 159.5 L 245.5 156 L 244 155.5 L 249.5 154 Z "
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 155 L 150 155.5 Q 142.7 160.2 132.5 162 L 127.5 166 L 127 164.5 L 136.5 158 L 148.5 155 Z "
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 155 L 363.5 158 L 373 164.5 L 372.5 166 L 367.5 162 L 352.5 157 L 351.5 155 Z "
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 343.5 158 L 352.5 162 Q 362 162 368.5 165 L 376 171.5 L 377 177 L 358.5 174 L 348 165.5 L 349.5 166 L 364.5 168 L 364.5 167 L 346.5 162 L 343.5 158 Z M 359 170 L 359 171 L 362 171 L 359 170 Z M 363 171 L 363 172 L 367 172 L 363 171 Z "
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 396.5 160 L 397 161.5 L 393 171.5 L 395 170.5 L 397.5 166 L 398 167.5 L 386.5 191 L 385 182.5 L 388 173.5 L 396.5 160 Z "
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 161 L 176 162.5 Q 162.1 173.6 153.5 190 Q 150.3 188.3 154 186.5 Q 160.5 172 172.5 163 L 175.5 161 Z "
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 162 L 114 177.5 L 115 187.5 L 113.5 192 L 111 183.5 L 102 165.5 L 103 165.5 L 107.5 173 L 108 171.5 Q 104.2 167.6 104.5 162 Z "
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 162 L 326.5 162 L 340 175.5 L 348 190 Q 345.3 191.1 346 188.5 Q 339.4 176.1 329.5 167 L 324.5 162 Z "
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 163 L 291.5 163 L 299 168.5 L 296.5 172 L 293.5 167 L 286.5 165 L 281 169.5 Q 278.2 172.2 279 178.5 L 282.5 183 L 287.5 184 Q 290 182.8 289 179 Q 286.3 180.1 287 177.5 L 288.5 178 L 296 181.5 L 292 183.5 L 289.5 188 Q 280.1 186.9 276 180.5 L 275 172.5 L 279 165 L 283.5 163 Z "
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 168 Q 203.3 167.3 204 169.5 Q 205.1 172.8 202.5 172 L 200.5 171 L 193 176.5 L 193 181.5 L 197.5 188 L 204.5 190 L 212 184.5 Q 211.3 181.9 214 183 Q 213.2 189.1 207.5 192 L 198.5 193 L 191 186.5 L 190 177.5 L 194.5 171 L 199.5 168 Z "
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 170 L 111 188.5 L 112 197.5 L 110 196.5 L 100 177.5 L 101 177.5 L 104.5 183 L 105 181.5 L 100 171.5 L 100.5 170 Z "
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 398.5 173 L 399 174.5 L 395 182.5 L 398 180.5 L 399.5 178 L 399 179.5 L 389.5 198 L 388 193.5 Q 391.1 181.1 398.5 173 Z "
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 176 L 143.5 178 L 129.5 182 L 122 186.5 L 123.5 187 L 137.5 183 L 137.5 184 L 124.5 189 L 119.5 193 L 119 190.5 L 122 187.5 L 121 186.5 Q 120.5 182.5 123.5 182 L 129.5 179 L 144.5 176 Z "
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 311.5 176 L 317.5 183 L 314.5 182 L 302 195.5 L 307.5 201 L 308.5 200 Q 310.8 199.3 310 201.5 L 306.5 204 L 295.5 192 L 298.5 193 L 312 178.5 L 311.5 176 Z "
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 176 L 360.5 178 L 366.5 178 L 373.5 180 L 379 184.5 L 380 186.5 L 378.5 186 L 371.5 182 L 358.5 179 L 355.5 176 Z "
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 183 L 375.5 186 L 381 190.5 L 380.5 193 L 375.5 189 L 362.5 184 L 362.5 183 Z "
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 185 L 110 202.5 L 108.5 202 L 105 199.5 Q 99.2 193.8 99.5 185 Z "
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 400.5 186 L 401 188.5 Q 398.6 198.1 391.5 203 Q 389.3 203.8 390 201.5 Q 397.1 195.6 400.5 186 Z "
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 187 L 178 187.5 L 177 190.5 L 189.5 201 L 193.5 202 L 195 201.5 L 190 209 L 188 208.5 L 189 205.5 L 175.5 194 L 172.5 194 L 171 194.5 L 176.5 187 Z "
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 402.5 189 L 403 191.5 L 401 197.5 L 396 205 L 390.5 207 L 398 198.5 L 402.5 189 Z "
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 192 Q 102.6 200.9 110 206.5 L 107.5 207 Q 99.4 202.1 98.5 192 Z "
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 194 L 151 196.5 Q 140.9 211.7 140 235 Q 136.5 236.1 138 228.5 L 143 208.5 L 150.5 194 Z "
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349 194 Q 351.7 192.9 351 195.5 L 359 213.5 L 362 227.5 L 362 234.5 L 360 233.5 L 358 217.5 L 349 194 Z "
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 199 L 132.5 201 L 120.5 206 L 115.5 210 L 116 208.5 L 119.5 204 L 133.5 199 Z "
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 200 L 380.5 204 L 385 208.5 L 384.5 211 Q 379.2 204.2 369.5 202 L 368.5 200 Z "
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 203 Q 101.7 211.8 108 216.5 L 105 217.5 L 107.5 221 L 100 215.5 L 98 211.5 L 101 213.5 L 102.5 216 L 104 215.5 L 99 207.5 L 99.5 203 Z "
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 203 L 401 204.5 L 399 212.5 L 402 211.5 L 397.5 219 L 393 221 L 395 217.5 L 392 216.5 L 401.5 203 Z M 399 213 L 396 217 L 399 215 L 399 213 Z "
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 204 L 165 208 L 182.5 215 L 185.5 213 L 185 214.5 L 181.5 222 L 179.5 218 L 173.5 215 Q 169.3 219.1 169 226 L 177.5 228 L 180 226.5 L 177 236 L 175 235.5 L 176 233.5 L 173.5 231 L 157.5 225 L 155 226.5 L 158.5 218 L 160.5 222 L 167 224 L 170 214.5 Q 168 211.5 162.5 212 L 160 213.5 L 164.5 204 Z "
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 205 L 135 205.5 L 121.5 211 L 114.5 217 L 114 214.5 L 122.5 208 L 133.5 205 Z "
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 309.5 205 Q 312.1 208.4 319.5 207 L 327.5 205 L 335.5 205 L 337 206.5 L 332 211.5 L 322 223.5 L 321.5 228 L 317 219.5 L 318.5 220 L 323 217.5 L 324 213.5 L 320.5 209 L 314 211.5 L 313.5 213 L 309 206.5 L 309.5 205 Z M 326 208 L 324 210 L 327 213 L 330 209 L 326 208 Z "
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 205 L 377.5 208 L 386 214.5 L 385.5 217 L 380.5 212 L 365.5 206 L 365.5 205 Z "
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 211 L 132 211.5 Q 121 213 116 220.5 L 113.5 224 L 113 221.5 L 119.5 214 L 126.5 211 Z "
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 211 Q 381.3 211.7 386 219.5 L 387 223.5 L 385 222.5 L 378.5 215 L 372.5 212 L 369.5 212 L 369.5 211 Z "
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251 213 L 254 214.5 L 256 219.5 L 254 222.5 L 256.5 221 Q 259.1 220.2 258 223.5 L 251.5 236 L 247 226.5 L 246 220.5 L 249 222.5 L 251.5 227 L 254 223 Q 251.3 224.1 252 221.5 L 254 218 L 251.5 217 Q 250.3 219.3 249 216.5 L 251 213 Z "
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 217 Q 98.1 224.4 103.5 228 L 107 230.5 L 105.5 234 Q 99.4 232.6 97 227.5 L 98.5 228 L 100 227.5 L 96 220.5 L 96.5 217 Z "
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 217 L 128 217.5 L 116 226.5 L 114 230.5 L 116.5 229 L 122.5 226 L 120.5 229 L 114 234.5 L 113 236.5 L 114.5 237 Q 115.3 234.3 119.5 235 L 119.5 236 L 114 239.5 L 112.5 242 L 112 239.5 L 113 237.5 L 113 235.5 L 114 231.5 L 113 228.5 L 119.5 220 L 126.5 217 Z "
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 371.5 217 L 377.5 218 L 386 225.5 L 388 230.5 L 384 227.5 L 378.5 221 L 371.5 218 L 371.5 217 Z "
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 218 Q 251.5 218.5 251 222.5 L 250 222.5 L 248.5 218 Z "
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 403.5 218 L 404 221.5 L 399 228.5 L 400.5 229 L 403 227.5 L 400.5 231 L 394.5 234 L 393 231.5 Q 400.5 227 403.5 218 Z "
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 377.5 226 Q 384 227.5 387 232.5 L 388 236.5 L 388 238.5 L 389 241.5 L 387 242 L 383.5 237 L 380 235.5 L 383.5 235 L 386 236 L 379.5 228 L 377.5 226 Z "
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 229 L 347 236.5 L 330 245.5 L 348 250 L 349 257.5 L 346.5 256 L 333.5 257 L 327 259.5 Q 328 263.3 325 262 L 325.5 252 L 326 254 L 339.5 253 L 342 251.5 L 325 247 L 325 243 L 326.5 243 L 340 236.5 L 326.5 236 L 325 239 L 323 238.5 L 323 230.5 L 324 230.5 Q 323.3 232.8 325.5 232 L 326.5 233 L 341.5 233 L 345 232 L 345.5 229 Z "
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 232 Q 99.8 237 106 238 Q 107.3 241 103.5 240 L 97 234.5 L 96.5 232 Z "
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 403.5 232 L 404 233.5 Q 401.6 239.2 394.5 240 L 396.5 237 L 403.5 232 Z "
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 238 L 94 246.5 L 96.5 254 L 97.5 249 L 100.5 257 L 101.5 253 L 104.5 263 L 105.5 257 Q 109.3 260.2 109 267.5 L 108 268.5 L 106.5 283 L 93.5 257 L 93 258.5 Q 100.1 269.4 104 283.5 L 102.5 283 Q 90.5 280 84 271.5 L 83 268.5 L 84.5 269 L 89.5 272 L 84 265.5 L 83 263.5 L 84.5 264 L 87.5 265 L 84.5 261 Q 82.3 261.8 83 259.5 L 82 257.5 L 83.5 258 L 86.5 259 L 85.5 257 L 83 255.5 L 84 252.5 L 83 248.5 L 83 246.5 L 83.5 238 Z "
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 416.5 238 L 418 245.5 Q 414.5 247 417 248.5 L 416 252.5 L 418 253 L 416.5 256 L 413 258.5 L 414.5 259 L 418 257 Q 418.8 261.7 414.5 263 L 412 264.5 L 413.5 265 L 416.5 263 L 417 264.5 L 413 269.5 L 414.5 270 L 417 268.5 L 412.5 276 L 396.5 284 L 396 282.5 L 404 263.5 L 403 263.5 L 395 282 L 393 281.5 L 393 273.5 L 392 272.5 L 392 260.5 L 394.5 257 L 395.5 264 L 398.5 254 L 399.5 257 L 402.5 250 L 403.5 253 L 406 246.5 L 411.5 241 L 416.5 238 Z "
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153 240 L 157 240 L 157 241.5 Q 153.2 243.7 154 250.5 L 157.5 255 L 167.5 256 L 172 252.5 Q 174.3 249.3 173 242.5 L 172 240.5 L 175 242.5 L 176 250.5 L 171.5 258 Q 168.2 261.2 160.5 260 L 153 254.5 Q 150.3 250.7 152 242.5 L 153 240 Z "
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 241 L 139 241.5 L 139 256 Q 132.9 255.2 130 249.5 Q 129.5 244.5 133.5 244 L 137.5 241 Z "
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 241 L 241.5 246 Q 243 242.5 244.5 245 L 246.5 245 L 250.5 241 L 253 241 L 256.5 246 L 258.5 245 L 261.5 247 L 269 243 L 270 255 L 277 256 L 278.5 259 L 284 260 L 280 267.5 L 283.5 273 L 290 277.5 L 282 283.5 L 282 287 Q 279.3 285.9 280 288.5 L 284 294.5 L 277 297 L 275.5 300 Q 267.3 297.3 270 305.5 L 269 312 L 260.5 308 Q 259.3 311 255 310 L 251.5 315 L 246.5 310 L 244.5 310 Q 243 312.5 241.5 309 L 233.5 314 L 230 300 L 226 298.5 Q 226.8 296.3 224.5 297 L 218 294.5 Q 221.6 292.6 221 286.5 L 220 283 L 210 277.5 L 220 271.5 L 221 266.5 L 218 260 L 224.5 259 L 226 257.5 Q 225.2 254.9 228.5 256 L 231 252.5 L 231 248.5 L 233.5 241 Z M 250 246 L 249 253 L 248 251 L 246 250 L 247 252 L 247 254 L 245 250 L 244 253 L 243 251 L 242 255 L 243 256 L 240 252 L 238 251 L 239 254 L 240 255 L 238 253 L 236 252 L 238 257 L 235 256 L 236 258 L 235 257 L 234 259 L 236 261 L 233 259 L 232 261 L 233 262 L 231 261 L 232 264 L 228 262 L 228 264 L 226 265 L 229 267 L 226 268 L 229 270 L 226 271 L 228 272 L 224 273 L 229 274 L 229 275 Q 223 273 224 277 L 214 278 L 225 279 L 225 281 L 227 280 L 229 281 L 225 283 L 228 284 L 226 285 L 229 286 L 227 287 L 226 289 L 228 288 L 229 289 L 225 291 L 225 292 L 230 290 L 230 292 L 232 291 L 230 295 L 232 294 L 235 295 L 236 295 L 234 298 L 236 298 L 233 302 L 235 302 L 238 300 L 236 303 L 237 304 L 238 302 L 240 301 L 238 304 L 239 305 L 240 303 L 242 302 L 241 305 L 242 306 L 244 303 L 245 305 L 247 301 L 248 305 L 249 302 L 250 309 L 251 304 Q 250 309 253 310 L 254 305 L 255 308 L 256 302 L 257 305 L 258 301 L 259 305 L 260 305 L 259 302 L 260 300 L 261 304 L 263 305 L 261 301 L 264 302 L 263 300 L 266 301 L 264 297 L 268 299 L 266 295 L 269 296 L 269 295 L 269 293 L 272 295 L 271 292 L 275 294 L 274 291 L 276 292 L 277 292 L 272 289 L 276 288 L 274 287 L 276 286 L 275 285 L 278 283 L 275 281 Q 284 281 288 278 Q 284 274 275 275 L 279 273 L 279 272 L 276 273 L 276 270 L 274 269 L 276 268 L 273 267 L 276 265 L 276 264 L 273 265 L 274 262 L 271 263 L 272 260 L 269 262 L 270 260 L 269 259 L 266 261 L 268 257 L 264 259 L 265 257 L 263 257 L 264 255 L 264 253 L 262 256 L 261 256 L 263 252 L 263 250 L 261 253 L 260 250 L 258 254 L 257 250 L 256 253 L 255 248 L 254 250 L 253 250 Q 254 245 251 246 L 251 251 L 250 246 Z M 267 253 L 265 256 L 267 255 L 267 253 Z "
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 241 L 371 248.5 Q 367.8 254.9 361 256 L 362 252.5 L 362.5 241 Z "
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 260 L 255.5 260 L 264 264 L 269 273.5 L 269 281.5 L 264 291 L 256.5 295 L 246.5 295 L 237 288.5 Q 233.3 285.7 234 278.5 L 236 279.5 Q 236.8 287.8 242.5 291 Q 246.5 294.5 255.5 293 Q 262.4 291.4 265 285.5 L 268 277.5 L 264 268.5 L 260.5 265 Q 256.7 260.3 246.5 262 L 238 268.5 L 234.5 277 L 234 272.5 L 240.5 263 L 246.5 260 Z "
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137 262 Q 140.7 260.6 139 266.5 L 143 286.5 L 149 300.5 L 149 303.5 L 147 302.5 L 140 283.5 L 137 262 Z "
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361 262 Q 364.5 260.9 363 268.5 L 359 287.5 Q 356.8 297.3 351.5 304 L 351 301.5 Q 360.2 285.5 361 262 Z "
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 262 L 392 285.5 L 389.5 293 L 388.5 283 L 387.5 297 L 385.5 291 L 385 294.5 L 386 299.5 L 384.5 303 L 378 285.5 L 378 277.5 L 379.5 275 Q 379.4 282.1 382.5 286 L 383 283.5 L 382 282.5 L 382 272.5 L 384.5 268 L 387.5 283 L 388 276.5 L 387 275.5 L 387 267.5 L 389.5 262 Z M 385 288 L 384 291 L 385 291 L 385 288 Z "
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 264 L 113 266.5 L 113 277.5 Q 110.7 278.8 112 283.5 L 113 283.5 L 116 269.5 L 115.5 268 L 119 275.5 L 119 279.5 L 116 288.5 L 117 288.5 L 121.5 276 L 122 286.5 L 115.5 302 L 114 296.5 L 115 292.5 L 114 292.5 L 112.5 296 L 111.5 285 L 110.5 292 Q 111.1 286.9 108 285.5 L 108 280.5 L 111.5 264 Z M 116 289 L 115 292 L 116 292 L 116 289 Z "
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 266 L 257 269 L 257 271 L 261 273 L 261 275.5 Q 265 277.5 261 279.5 L 261 281.5 L 256.5 286 L 254 287.5 Q 254.8 289.8 252.5 289 L 251.5 290 L 247.5 286 Q 244.2 287.1 245 284.5 L 240 278.5 L 240 276.5 Q 244.4 274.1 245 269 L 247.5 269 L 251.5 266 Z M 251 273 Q 250 276 253 275 L 253 280 Q 250 279 251 282 L 250 284 L 253 283 L 254 284 L 253 282 L 255 281 L 255 279 L 254 277 L 256 274 L 255 274 L 251 273 Z M 248 274 Q 245 275 247 277 Q 246 280 249 279 L 250 278 Q 246 276 249 275 L 248 274 Z M 250 275 L 251 277 Q 252 274 250 275 Z M 246 276 L 245 279 L 246 279 L 246 276 Z M 258 277 L 258 278 L 261 278 L 258 277 Z M 251 278 L 249 280 L 251 280 L 251 278 Z "
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 277 L 89.5 285 L 107 294.5 L 105.5 295 L 90.5 289 L 86 284.5 Q 83 281.8 84.5 277 Z "
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 415.5 278 L 416 281.5 L 409.5 289 L 393.5 295 L 393.5 294 L 407.5 287 L 413 282.5 L 415.5 278 Z "
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 410.5 279 L 410 280.5 L 408.5 283 L 395.5 290 L 395 288.5 L 410.5 279 Z "
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 280 L 92.5 282 L 101.5 285 L 106 289.5 L 104.5 290 L 93.5 284 L 90.5 280 Z "
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 281 L 126 287.5 L 118.5 309 L 118 300.5 Q 122.8 292.3 124.5 281 Z "
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 375.5 281 L 383 305.5 L 381.5 309 L 381 304.5 L 375 291.5 L 375.5 281 Z "
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 288 L 93.5 294 Q 103.4 295.6 110 300.5 L 109.5 302 L 91.5 295 L 86 289.5 L 86.5 288 Z "
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 288 L 110 295.5 L 124.5 322 L 125 319.5 L 124 316.5 L 129.5 301 L 130 306.5 L 125 323.5 Q 137 344 153.5 360 L 154 358.5 Q 149.1 354.4 151 343.5 L 153.5 337 L 154 339.5 L 153 340.5 L 153 352.5 L 155 359.5 L 154 360.5 L 166.5 373 L 193.5 392 L 213.5 400 L 221 401 L 220 405 L 211.5 404 L 201.5 400 L 176.5 385 L 174.5 387 L 159.5 389 L 151.5 393 L 153.5 390 L 162.5 386 L 176 384.5 L 153 364.5 Q 134.7 344.8 121 320.5 L 110 298.5 L 107.5 288 Z "
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 288 L 128 293.5 L 123 308.5 L 122.5 316 Q 119.5 314 120 308.5 L 127.5 288 Z "
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 413.5 288 L 414 289.5 L 410.5 294 L 405.5 297 L 390.5 302 L 393.5 298 L 404.5 295 L 413.5 288 Z "
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 289 L 380 307.5 L 380 312.5 L 377.5 316 L 377 307.5 L 373 296.5 L 372.5 289 Z "
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 392.5 289 L 393 290.5 Q 383.2 317.2 368 338.5 L 369.5 338 L 375.5 336 L 390.5 335 L 390.5 336 L 368.5 341 L 367.5 339 Q 355.1 358.1 338.5 373 L 331 379.5 L 340.5 380 L 343 381.5 L 331 382 Q 332.1 379.3 329.5 380 Q 320.5 389 308.5 395 L 291.5 403 L 280 405 Q 277.9 399.8 282.5 401 Q 304.2 395.7 319 383.5 L 317.5 383 L 316 383.5 L 319 376.5 L 319.5 364 Q 322.2 368.3 321.5 376 Q 325.4 370.4 324 359.5 L 323 357.5 L 324 357.5 Q 327 361.5 326 369.5 L 323 378.5 L 319 382.5 L 320.5 383 Q 334.8 373.3 346 360.5 L 345 358.5 Q 349 352 347 339.5 L 346 336.5 L 347 336.5 Q 350.5 343 349 354.5 L 347 358.5 L 353 353.5 L 352.5 352 L 351 352.5 L 352 340.5 L 351 336.5 L 352 336.5 L 353.5 341 L 354 337.5 L 353 336.5 L 353 321.5 L 354 321.5 L 354 327.5 L 356 334.5 L 356 346.5 L 354 350.5 L 358 347.5 L 375 322.5 L 370 305.5 L 370 301.5 L 371 301.5 L 376 315.5 L 376 319.5 L 375 321.5 L 377 320.5 L 390 296.5 L 392.5 289 Z "
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 412.5 294 L 413 295.5 L 409.5 300 Q 402.2 304.2 391.5 305 L 388.5 307 L 390.5 304 L 404.5 300 L 412.5 294 Z "
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 295 L 95.5 300 L 105.5 302 L 112 306.5 L 110.5 306 L 94.5 302 L 88 296.5 L 88.5 295 Z "
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 301 L 96.5 306 L 108.5 308 L 115 311.5 L 111.5 312 L 106.5 311 L 106.5 312 Q 115.6 312.4 119 318.5 L 117.5 319 L 99.5 315 L 93 309.5 L 95.5 309 Q 98.8 311.7 105.5 311 L 105.5 310 Q 94 310 89 303.5 L 88.5 301 Z "
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 411.5 301 L 412 302.5 Q 406.3 309.8 394 310.5 L 399.5 311 L 406.5 309 L 402.5 314 L 381.5 319 L 384.5 315 L 394 311.5 L 388.5 311 L 386.5 312 L 387.5 310 L 394.5 307 L 405.5 305 L 411.5 301 Z "
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 308 L 140 319.5 L 137 334.5 L 138 338.5 L 136 337.5 L 135 330.5 L 139 316.5 L 139.5 308 Z "
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151 308 Q 153.7 306.9 153 309.5 Q 161.3 324.7 174 335.5 L 174 337.5 L 164 328.5 Q 155.4 319.7 151 308 Z "
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 308 L 349 310.5 L 342 321.5 L 329 337 L 326.5 338 L 326 335.5 Q 339.3 323.8 348.5 308 Z "
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 309 L 361 315.5 L 365 328.5 L 365 335.5 L 362.5 339 L 362 337.5 Q 364.5 336 363 330.5 L 360 317.5 L 360.5 309 Z "
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 315 L 133 316.5 L 132 321.5 L 134 321.5 L 132.5 331 Q 128.3 329.7 129 323.5 L 132.5 315 Z "
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 367.5 315 Q 371.9 318.1 371 326.5 L 367.5 332 L 367 329.5 L 368 326.5 L 366 321.5 L 369 322.5 L 367.5 315 Z "
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 316 L 100.5 319 L 114.5 320 L 122 323.5 L 118.5 324 L 117.5 323 L 109.5 323 L 100.5 321 L 96 317.5 L 96.5 316 Z "
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 404.5 316 L 401.5 320 L 396.5 322 L 381.5 323 L 379 324 Q 377.9 321.3 380.5 322 L 384.5 320 L 399.5 319 L 404.5 316 Z "
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 319 Q 257 325.3 258 335 Q 255.3 336.1 256 333.5 L 251.5 328 L 246.5 335 L 246 331.5 L 251.5 319 Z "
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 320 L 147.5 339 L 149.5 335 L 150 336.5 L 148 342.5 L 148 348.5 L 150 352.5 L 145 348.5 L 144 336.5 L 145 335.5 L 146.5 320 Z "
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 324 Q 362.9 329.6 361 340.5 L 358.5 344 L 358 341.5 L 359 340.5 L 359.5 324 Z "
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 325 L 142 343.5 L 140 342.5 Q 137.8 337.8 139 329.5 L 140.5 325 Z "
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 326 L 400.5 328 L 401.5 326 Z "
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 327 L 109.5 330 L 123.5 331 L 128 334.5 L 125.5 335 L 103.5 330 L 100.5 327 Z "
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 397.5 328 L 399 328.5 L 389.5 332 L 384.5 332 L 372.5 335 L 374.5 332 L 397.5 328 Z "
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 332 L 256 337.5 L 254 337.5 L 255 339.5 L 251.5 342 Q 248.3 340.3 248 335.5 L 251 333.5 L 250 336.5 Q 251.3 339.3 252.5 337 L 254 336.5 L 252.5 332 Z "
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 333 L 155 334.5 L 154.5 336 L 154 334.5 L 155.5 333 Z "
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 335 L 123.5 336 L 128.5 337 L 132 339.5 L 127.5 340 L 109.5 336 L 109.5 335 Z "
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 337 L 111.5 340 L 128.5 341 L 134 343.5 L 124.5 344 L 110.5 341 Q 105.9 339.8 105.5 337 Z "
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 339 Q 185.5 338.5 186 341.5 Q 186.5 345.5 183.5 346 L 181.5 347 L 179 346 L 179 340.5 L 180.5 340 L 181.5 339 Z "
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 317.5 339 L 321 340.5 L 322 343.5 L 321 346 L 318.5 347 L 315 344.5 Q 313.1 339.1 316.5 340 L 317.5 339 Z "
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 390.5 339 L 392 339.5 L 377.5 344 L 366.5 344 L 367.5 342 L 383.5 341 L 390.5 339 Z "
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 343 L 158 345.5 Q 155.5 347 157 352.5 L 161 364.5 L 157 361.5 Q 154.4 355.6 156 345.5 L 157.5 343 Z "
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 343 L 345 349.5 L 345 354.5 L 343 361.5 L 339.5 365 L 340 363.5 L 343 354.5 L 343 345.5 L 342.5 343 Z "
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 344 L 114.5 346 L 134.5 346 L 138 348.5 L 129.5 349 L 128.5 348 L 117.5 348 L 111.5 346 L 110.5 344 Z "
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 344 L 165 363.5 L 168 371.5 L 167 371.5 Q 162 367.5 162 358.5 L 164.5 344 Z "
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335.5 345 L 338 356.5 L 338 363.5 L 332.5 372 L 333 370.5 L 335 364.5 L 335.5 345 Z "
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 345 L 389 345.5 L 382.5 348 L 362.5 349 L 363.5 347 L 366.5 346 L 386.5 346 L 387.5 345 Z "
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 311.5 348 L 312 349.5 Q 294.4 364.4 264.5 367 L 265.5 365 Q 294.2 362.2 311.5 348 Z "
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 349 L 208.5 359 L 224.5 364 L 234.5 365 L 236 366.5 L 229.5 367 Q 213.7 364.3 201.5 358 L 190.5 352 L 188.5 349 Z "
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 350 L 120.5 351 L 139.5 351 L 141 352.5 L 124.5 353 L 117.5 351 L 117.5 350 Z "
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 350 L 383 350.5 Q 374.5 355 359.5 353 L 360.5 351 L 379.5 351 L 380.5 350 Z "
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 351 Q 334.6 355.9 333 365.5 L 330 373.5 L 327.5 376 Q 325.3 376.8 326 374.5 L 331 364.5 L 331.5 351 Z "
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 352 L 121.5 355 L 134.5 356 L 143 354 Q 144.1 356.7 141.5 356 Q 138 360 128.5 358 L 120.5 356 Q 115.9 354.8 115.5 352 Z "
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 352 L 169 363.5 L 175 376.5 L 173.5 376 L 171 374.5 L 167 364.5 L 167 355.5 L 168.5 352 Z "
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 353 L 384 353.5 Q 376.8 358.8 363.5 358 L 357 356 L 357.5 354 L 364.5 356 L 373.5 356 Q 374.7 353.8 379.5 355 L 382.5 353 Z "
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 357 L 144 358.5 Q 140.8 362.3 133.5 362 L 134.5 360 L 137.5 360 L 143.5 357 Z "
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 357 L 367 360 Q 368.4 363.7 362.5 362 L 356 358.5 L 356.5 357 Z "
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 359 L 147 360.5 L 142.5 363 L 143.5 361 L 146.5 359 Z "
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 360 Q 175 369.5 178.5 375 L 180 364.5 L 181.5 362 L 182 363.5 L 181 364.5 L 181 374.5 L 184 383.5 L 181.5 382 L 178 379.5 L 175 373.5 L 174 365.5 L 175.5 360 Z "
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 354 360 L 358 362.5 L 355.5 363 L 354 360 Z "
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243 366 L 256.5 366 L 257 367.5 L 252.5 373 L 249.5 374 L 243 366 Z "
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 367 L 153.5 367 L 154 369 L 143.5 369 L 132.5 372 L 132.5 371 L 142.5 367 Z "
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 367 L 187 368.5 Q 184.3 370.3 186 376.5 L 191 387.5 L 186 383.5 Q 183 379.5 184 371.5 L 186.5 367 Z "
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 367 L 194 370.5 L 195 383.5 L 201 392.5 L 199.5 392 L 194 387.5 L 192 382.5 L 192.5 367 Z "
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 313.5 367 Q 317.9 370.1 316 379.5 L 311.5 387 L 309.5 388 L 311 385.5 L 314 377.5 L 314 368.5 L 313.5 367 Z "
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 367 L 357.5 367 L 366 370.5 L 364.5 371 Q 357.1 367.9 346 368.5 L 347.5 367 Z "
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 368 L 308 383.5 L 301.5 392 L 300 391.5 L 303 388.5 L 306 380.5 Q 305 372.5 307.5 368 Z "
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 371 L 160 372 L 159.5 374 L 146.5 374 L 133.5 377 L 133.5 376 L 149.5 371 Z "
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 371 L 293 376.5 L 294 385.5 Q 292.5 394 286.5 398 L 282.5 399 L 288 392.5 Q 292.5 388 292 378.5 L 289.5 371 Z "
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 371 L 356.5 372 L 365 375.5 L 362.5 376 Q 353.3 372.7 340 373.5 L 344.5 371 Z "
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 372 L 210 373.5 L 208 382.5 Q 210.1 392.9 217.5 398 L 219 398.5 L 216.5 399 L 210 394.5 Q 205.2 389.3 207 377.5 L 210.5 372 Z "
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 374 L 200.5 386 L 201 382 Q 204.3 380.7 203 385.5 L 208 395.5 L 206.5 396 L 202 392.5 L 197 383.5 L 197.5 374 Z "
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 375 L 163.5 376 L 165 377.5 L 148.5 378 L 139.5 381 L 139.5 380 L 149.5 376 Q 155 377.5 156.5 375 Z "
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 375 L 354.5 377 L 363 381.5 L 361.5 382 L 351.5 378 L 335 377.5 L 340.5 375 Z "
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 376 L 304 379.5 Q 302.3 389.8 295.5 395 L 292.5 396 L 293 394.5 L 298.5 381 L 299.5 386 L 303.5 376 Z "
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 378 L 288 387.5 L 278.5 400 L 278 396.5 L 279 395.5 L 279 387.5 L 277 384.5 L 280 386.5 L 281.5 392 Q 287.5 388 287.5 378 Z "
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 379 Q 213.4 387.6 218.5 392 Q 218.6 386.1 222.5 384 L 222 385.5 L 221 394.5 L 222 398.5 L 217 394.5 L 212 386.5 L 212.5 379 Z "
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 380 L 168.5 380 L 169 382 L 154.5 383 L 154.5 382 L 160.5 380 Z "
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 381 L 253.5 381 L 259.5 386 Q 265.9 385.6 268 389.5 L 269 393.5 L 276 401.5 L 276 408.5 L 271 414.5 L 271 417.5 L 266.5 424 L 262.5 425 L 254.5 432 L 246.5 432 L 231 421.5 L 229 413 L 226 411.5 Q 222.6 408.9 224 401.5 L 234.5 387 L 240.5 386 L 246.5 381 Z M 251 388 L 249 390 Q 250 396 248 395 L 246 395 L 246 396 L 242 396 L 242 399 L 239 399 L 240 402 Q 239 404 234 404 L 239 406 L 235 408 L 239 408 Q 241 409 239 411 Q 238 413 241 412 L 241 415 L 244 416 L 246 419 L 249 417 L 249 427 L 251 428 L 252 419 L 254 419 L 254 417 L 256 417 L 256 416 L 259 415 Q 258 411 261 412 L 261 408 L 265 408 L 261 406 L 266 404 L 262 403 Q 258 401 262 400 L 258 399 L 259 397 L 255 396 L 255 394 L 253 395 Q 250 393 251 388 Z M 227 404 L 229 408 L 231 407 Q 232 402 227 404 Z M 271 404 L 269 406 Q 271 410 273 407 Q 274 403 271 404 Z "
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325 385 L 334.5 385 L 348 391.5 L 346.5 392 Q 338.5 386.3 325 387 L 325 385 Z "
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 389 L 180.5 389 L 181 391 L 166.5 392 L 149.5 399 L 150.5 397 Q 158.5 391.5 169.5 389 Z "
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 389 L 330.5 389 L 337.5 391 L 351 398.5 L 349.5 398 L 333.5 392 L 319 390.5 L 320.5 389 Z "
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 390 L 225 391.5 L 224.5 397 L 223 393.5 L 225.5 390 Z "
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 275.5 391 Q 278.3 392.4 277 397 L 275 397 L 275.5 391 Z "
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 392 L 350.5 394 L 349.5 392 Z "
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 393 L 186.5 393 L 190 395.5 L 189.5 397 L 181.5 397 L 173.5 400 L 174.5 398 L 178 396.5 L 173.5 396 L 163.5 399 L 161.5 401 L 163.5 398 L 175.5 393 Z "
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 393 L 324.5 393 L 338 399.5 L 336.5 399 L 327.5 396 L 322.5 396 L 322.5 397 L 328 399.5 L 326.5 400 Q 320.4 395.8 310 397 L 311.5 394 L 314.5 393 Z "
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 398 Q 255.1 396.9 257 401.5 L 258 409.5 L 254.5 414 L 247.5 415 L 243 411.5 L 242 403.5 L 245.5 399 L 247.5 398 Z M 249 403 L 248 404 Q 244 403 246 409 Q 247 412 252 411 L 255 407 L 254 405 Q 253 402 249 403 Z "
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 399 L 197.5 399 L 198 401 L 185.5 402 L 175.5 407 L 179.5 402 L 186.5 399 Z "
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302 399 L 313.5 399 Q 321.3 401.3 326 406.5 L 324.5 407 Q 316.1 400.6 302 401 L 302 399 Z "
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 401 L 204 402.5 L 185.5 408 L 185.5 407 L 199.5 401 Z "
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 401 L 304.5 402 Q 310.4 407.1 320 408.5 L 316.5 409 L 296.5 403 L 296.5 404 L 308 409.5 L 302.5 410 L 296 407 Q 297.1 409.7 294.5 409 L 291 404.5 L 292.5 405 L 295.5 403 L 298.5 401 Z "
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 403 L 206 405 L 209.5 404 L 204.5 410 L 204 408.5 L 205 406.5 L 203.5 407 L 196.5 410 L 192.5 410 L 192.5 409 L 205.5 403 Z "
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 408 L 183 408.5 L 180.5 409 L 180.5 408 Z "
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 408 Q 220.3 408.3 222 411.5 L 223 414.5 L 219.5 420 L 215.5 421 L 210 416.5 Q 209.2 410.7 212.5 409 L 215.5 408 Z "
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(18,18,18)",
    stroke: "rgb(18,18,18)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 408 Q 287.6 407.4 289 410.5 L 290 416.5 L 287.5 420 L 283.5 421 L 279 419 Q 277.4 416.9 278 411.5 L 282.5 408 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChicNGlamLogo);
export default __webpack_public_path__ + "static/media/chic-n-glam-logo.b00ace6449ad75a4366ff35772b31b30.svg";
export { ForwardRef as ReactComponent };